const $data = {
  product_showlist: {
    'commonpest': {
      bannerImg: require('../../static/images/phone/product/banner_common.jpg'),
      bannerImgPc: require('../assets/images/pc/product/banner_common.jpg'),
      title: '常见虫害',
      titleEn: 'Common Pests',
      bgcolor: '#00b7ed',
      wormlist: [
        {
          img: require('../../static/images/phone/product/cockroach.jpg'),
          imgPc: require('../assets/images/pc/product/cockroach.jpg'),
          title: '除蟑螂服务',
          star: 5,
          detail: '深度科学除蟑，安全又高效，和顽固小强优雅say bye-bye。',
          icon: 'cockroach',
          iconFont: '14px',
          infoUrl: 'zhanglang',
          cricle: {
            isLeft: true,
            isTop: true,
            x: '11px',
            y: '-11px',
            color: '#AACC03'
          },
          point: {
            isLeft: false,
            isTop: false,
            x: '-5px',
            y: '-25px',
            isblue: true
          }
        },
        // {
        //   img: require('../../static/images/phone/product/rats.jpg'),
        //   imgPc: require('../assets/images/pc/product/rats.jpg'),
        //   title: '灭老鼠服务',
        //   star: 5,
        //   detail: '全路径源头除鼠——真正解决鼠患，远不止抓到老鼠这么简单。',
        //   icon: 'rats',
        //   iconFont: '8px',
        //   infoUrl: 'laoshu',
        //   cricle: {
        //     isLeft: false,
        //     isTop: false,
        //     x: '-15px',
        //     y: '40px',
        //     color: '#00B7ED'
        //   },
        //   point: {
        //     isLeft: true,
        //     isTop: true,
        //     x: '0',
        //     y: '-20px',
        //     isblue: false
        //   }
        // },
        {
          img: require('../../static/images/phone/product/flea.jpg'),
          imgPc: require('../assets/images/pc/product/flea.jpg'),
          title: '灭跳蚤服务',
          star: 5,
          detail: '拜耳疗程式全面喷洒方案——告别无休止的叮咬瘙痒。',
          icon: 'flea',
          iconFont: '10px',
          infoUrl: 'tiaozao',
          cricle: {
            isLeft: true,
            isTop: true,
            x: '-12px',
            y: '40px',
            color: '#AACC03'
          },
          point: {
            isLeft: false,
            isTop: false,
            x: '-5px',
            y: '-25px',
            isblue: true
          }
        },
        {
          img: require('../../static/images/phone/product/ants.jpg'),
          imgPc: require('../assets/images/pc/product/ants.jpg'),
          title: '灭蚂蚁服务',
          star: 5,
          detail: '它们热衷抱团，我们专注团灭——连锁灭杀，摧毁整个蚁巢。',
          icon: 'ants',
          iconFont: '14px',
          infoUrl: 'mayi',
          cricle: {
            isLeft: true,
            isTop: true,
            x: '-12px',
            y: '40px',
            color: '#00B7ED'
          },
          point: {
            isLeft: true,
            isTop: true,
            x: '0',
            y: '-22px',
            isblue: false
          }
        },
        {
          img: require('../../static/images/phone/product/white_ant_check.jpg'),
          imgPc: require('../assets/images/pc/product/white_ant_check.jpg'),
          title: '白蚁灭治服务',
          star: 5,
          detail: '微小如白蚁，却可能悄然从内部将房屋蛀空——拜耳涟漪式微创灭巢技术，消灭蚁后蚁巢，守卫家园就现在。',
          icon: 'white_ant_check',
          iconFont: '14px',
          infoUrl: 'baiyikancha',
          cricle: {
            isLeft: true,
            isTop: true,
            x: '16px',
            y: '-11px',
            color: '#AACC03'
          },
          point: {
            isLeft: false,
            isTop: false,
            x: '-5px',
            y: '-25px',
            isblue: true
          }
        },
        // {
        //   img: require('../../static/images/phone/product/other.jpg'),
        //   imgPc: require('../assets/images/pc/product/other.jpg'),
        //   title: '综合虫害预防服务',
        //   star: 5,
        //   detail: '搬新家、大扫除，适合来一次全生态综合虫害预防，消除家中的虫害隐患。不忽视生活的角落细节，是健康美好生活的秘诀。',
        //   icon: 'other',
        //   iconFont: '14px',
        //   infoUrl: '/service/prevention',
        //   cricle: {
        //     isLeft: true,
        //     isTop: true,
        //     x: '-12px',
        //     y: '35px',
        //     color: '#00B7ED'
        //   },
        //   point: {
        //     isLeft: true,
        //     isTop: true,
        //     x: '0',
        //     y: '-22px',
        //     isblue: false
        //   }
        // },
      ],
      servePlan: [
        // {
        //   img: require('../../static/images/phone/product/specialty.jpg'),
        //   imgPc: require('../assets/images/pc/product/specialty.jpg'),
        //   title: '专业虫害鉴定服务',
        //   star: 5,
        //   detail: '不认识见到的是什么虫？拜耳精准虫害数据库，帮您识别害虫真身。',
        //   icon: 'specialty',
        //   iconFont: '14px',
        //   infoUrl: '/service/profession',
        //   cricle: {
        //     isLeft: false,
        //     isTop: true,
        //     x: '40px',
        //     y: '-10px',
        //     color: '#AACC03'
        //   },
        //   point: {
        //     isLeft: false,
        //     isTop: true,
        //     x: '-5px',
        //     y: '-20px',
        //     color: '#fff'
        //   }
        // },
        {
          img: require('../../static/images/phone/product/contact.jpg'),
          imgPc: require('../assets/images/pc/product/contact.jpg'),
          title: '免费顾问咨询',
          star: 5,
          detail: '其他虫害问题？叮蛰虫、潮湿虫、织物虫，各种虫害我们都能解决。',
          icon: 'contact',
          iconFont: '14px',
          infoUrl: '',
          cricle: {
            isLeft: true,
            isTop: true,
            x: '-15px',
            y: '40px',
            color: '#00B7ED'
          },
          point: {
            isLeft: true,
            isTop: true,
            x: '0',
            y: '-11px',
            color: '#AACC03'
          }
        }
      ]
    },
    'termite': {
      bannerImg: require('../../static/images/phone/product/banner_white_ant.jpg'),
      bannerImgPc: require('../assets/images/pc/product/banner_white_ant.jpg'),
      title: '白蚁专区',
      titleEn: 'Termite Control',
      bgcolor: '#2b6636',
      wormlist: [
        {
          img: require('../../static/images/phone/product/white_ant_check.jpg'),
          imgPc: require('../assets/images/pc/product/white_ant_check.jpg'),
          title: '白蚁灭治服务',
          star: 5,
          detail: '微小如白蚁，却可能悄然从内部将房屋蛀空——拜耳涟漪式微创灭巢技术，消灭蚁后蚁巢，守卫家园就现在。',
          icon: 'white_ant_check',
          iconFont: '14px',
          infoUrl: 'baiyikancha',
          cricle: {
            isLeft: false,
            isTop: true,
            x: '16px',
            y: '-11px',
            color: '#fff'
          },
          point: {
            isLeft: false,
            isTop: false,
            x: '-5px',
            y: '-25px',
            isblue: true
          }
        },
        {
          img: require('../../static/images/phone/product/white_ant_prevent.jpg'),
          imgPc: require('../assets/images/pc/product/white_ant_prevent.jpg'),
          title: '白蚁预防',
          star: 5,
          detail: '抵御白蚁侵害最好的办法就是未雨绸缪。根据装修进度给房屋做一次全面预防，让你的房屋在白蚁来袭时固若金汤。',
          icon: 'white_ant_prevent',
          iconFont: '14px',
          infoUrl: 'baiyiyufang',
          cricle: {
            isLeft: true,
            isTop: true,
            x: '-12px',
            y: '40px',
            color: '#00B7ED'
          },
          point: {
            isLeft: true,
            isTop: true,
            x: '0',
            y: '-22px',
            isblue: false
          }
        },
      ],
      servePlan: [
        // {
        //   img: require('../../static/images/phone/product/specialty.jpg'),
        //   imgPc: require('../assets/images/pc/product/specialty.jpg'),
        //   title: '专业虫害鉴定服务',
        //   star: 5,
        //   detail: '不认识见到的是什么虫？拜耳精准虫害数据库，帮您识别害虫真身。',
        //   icon: 'specialty',
        //   iconFont: '14px',
        //   infoUrl: '/service/profession',
        //   cricle: {
        //     isLeft: false,
        //     isTop: true,
        //     x: '40px',
        //     y: '-10px',
        //     color: '#AACC03'
        //   },
        //   point: {
        //     isLeft: false,
        //     isTop: true,
        //     x: '-5px',
        //     y: '-20px',
        //     color: '#fff'
        //   }
        // },
        {
          img: require('../../static/images/phone/product/contact.jpg'),
          imgPc: require('../assets/images/pc/product/contact.jpg'),
          title: '免费顾问咨询',
          star: 5,
          detail: '其他虫害问题？叮蛰虫、潮湿虫、织物虫，各种虫害我们都能解决。',
          icon: 'contact',
          iconFont: '14px',
          infoUrl: '',
          cricle: {
            isLeft: true,
            isTop: true,
            x: '-15px',
            y: '40px',
            color: '#00B7ED'
          },
          point: {
            isLeft: true,
            isTop: true,
            x: '0',
            y: '-11px',
            color: '#AACC03'
          }
        }
      ]
    },
    'villapest': {
      bannerImg: require('../../static/images/phone/product/banner_villas.jpg'),
      bannerImgPc: require('../assets/images/pc/product/banner_villas.jpg'),
      title: '别墅除虫',
      titleEn: 'Villa Carefree',
      bgcolor: '#00617F',
      wormlist: [
        // {
        //   img: require('../../static/images/phone/product/villas.jpg'),
        //   imgPc: require('../assets/images/pc/product/villas.jpg'),
        //   title: '综合虫害管家服务',
        //   star: 5,
        //   detail: '房子大了，需要操心的事也变得更多。拜耳综合虫害管家服务，让你不用再为虫鼠健康隐患而担忧。',
        //   icon: 'villas',
        //   iconFont: '14px',
        //   infoUrl: '/service/bieshu',
        //   cricle: {
        //     isLeft: true,
        //     isTop: true,
        //     x: '-12px',
        //     y: '45px',
        //     color: '#00B7ED'
        //   },
        //   point: {
        //     isLeft: false,
        //     isTop: false,
        //     x: '-5px',
        //     y: '-22px',
        //     isblue: true
        //   }
        // },
        {
          img: require('../../static/images/phone/product/fly.jpg'),
          imgPc: require('../assets/images/pc/product/fly.jpg'),
          title: '蚊虫拜拜',
          star: 5,
          detail: 'TA的秘密是什么？为什么TA可以整个夏天不惧虫咬，悠然地和家人在花园漫步，在露台乘凉？',
          icon: 'fly',
          iconFont: '14px',
          infoUrl: '/service/feichong',
          cricle: {
            isLeft: false,
            isTop: false,
            x: '-15px',
            y: '40px',
            color: '#AACC03'
          },
          point: {
            isLeft: true,
            isTop: true,
            x: '0',
            y: '-20px',
            isblue: true
          }
        },
        // {
        //   img: require('../../static/images/phone/product/party.jpg'),
        //   imgPc: require('../assets/images/pc/product/party.jpg'),
        //   title: '派对准备',
        //   star: 5,
        //   detail: '当你为一场活动付出诸多心血，恼人的蚊虫却可能轻而易举让宾客败兴而归——拜耳高效控蚊，帮你请走这些不速之客。',
        //   icon: 'party',
        //   iconFont: '14px',
        //   infoUrl: '/service/paidui',
        //   cricle: {
        //     isLeft: true,
        //     isTop: true,
        //     x: '-12px',
        //     y: '40px',
        //     color: '#00B7ED'
        //   },
        //   point: {
        //     isLeft: false,
        //     isTop: false,
        //     x: '-5px',
        //     y: '-25px',
        //     isblue: false
        //   }
        // },
        // {
        //   img: require('../../static/images/phone/product/other.jpg'),
        //   imgPc: require('../assets/images/pc/product/other.jpg'),
        //   title: '综合虫害预防服务',
        //   star: 5,
        //   detail: '搬新家、大扫除，适合来一次全生态综合虫害预防，消除家中的虫害隐患。不忽视生活的角落细节，是健康美好生活的秘诀。',
        //   icon: 'other',
        //   iconFont: '14px',
        //   infoUrl: '/service/prevention',
        //   cricle: {
        //     isLeft: false,
        //     isTop: false,
        //     x: '18px',
        //     y: '-10px',
        //     color: '#fff'
        //   },
        //   point: {
        //     isLeft: true,
        //     isTop: true,
        //     x: '0',
        //     y: '-22px',
        //     isblue: true
        //   }
        // }
      ],
      servePlan: [
        // {
        //   img: require('../../static/images/phone/product/specialty.jpg'),
        //   imgPc: require('../assets/images/pc/product/specialty.jpg'),
        //   title: '专业虫害鉴定服务',
        //   star: 5,
        //   detail: '不认识见到的是什么虫？拜耳精准虫害数据库，帮您识别害虫真身。',
        //   icon: 'specialty',
        //   iconFont: '14px',
        //   infoUrl: '/service/profession',
        //   cricle: {
        //     isLeft: false,
        //     isTop: true,
        //     x: '40px',
        //     y: '-10px',
        //     color: '#AACC03'
        //   },
        //   point: {
        //     isLeft: false,
        //     isTop: true,
        //     x: '-5px',
        //     y: '-20px',
        //     color: '#fff'
        //   }
        // },
        {
          img: require('../../static/images/phone/product/contact.jpg'),
          imgPc: require('../assets/images/pc/product/contact.jpg'),
          title: '免费顾问咨询',
          star: 5,
          detail: '其他虫害问题？叮蛰虫、潮湿虫、织物虫，各种虫害我们都能解决。',
          icon: 'contact',
          iconFont: '14px',
          infoUrl: '',
          cricle: {
            isLeft: true,
            isTop: true,
            x: '-15px',
            y: '40px',
            color: '#00B7ED'
          },
          point: {
            isLeft: true,
            isTop: true,
            x: '0',
            y: '-11px',
            color: '#AACC03'
          }
        }
      ]
    }
  },
  product_info: {
    'zhanglang': {
      id: 'cockroachPlus',
      name: '蟑螂拜拜',
      iconName: 'iconn-cockroach',
      fullname: '蟑螂无忧 安全省心告别反复',
      bannerImg: require('../../static/images/product_info/infobg.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg.jpg'),
      title: '三步科学除虫',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '三区56点网格化排查<br>让蟑螂无处遁形',
          content: ['活体、残骸、卵鞘、排泄物、气味……','种种细微线索 尽在掌握','科学锁定小强种类、来源和诱因'],
          contentTip: [],
          img: require('../../static/images/product_info/infobanner03.png'),
          imgPc: require('../assets/images/pc/product_info/infobanner03.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '不同品种对症施药<br>安全又高效',
          content: ['隐藏式点胶、精准配比——规范操作','科学保护家中（老人、母婴、儿童、宠物等）敏感群体的健康'],
          contentTip: ['网格化胶饵密集布控，摧毁蟑螂巢穴','科学药液喷洒，形成持久防护膜'],
          img: require('../../static/images/product_info/infobanner02.jpg'),
          imgPc: require('../assets/images/pc/product_info/infobanner02.jpg'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '持续防控蟑螂复发<br>持久保障除蟑效果',
          content: ['专属虫害治理报告，全程服务可追溯','持久药效持续防控','<b>365天</b>ByepestCare服务保障计划','免除你的后顾之忧'],
          contentTip: [],
          img: require('../../static/images/product_info/bByepestCareTi.png'),
          imgPc: require('../assets/images/pc/product_info/bByepestCareTi.png'),
          classname: 'fontgreen',
        }
      ],
      type_list: [
        {
          title: '公寓除蟑螂',
          content: ['丑陋顽固、携带病菌的它','竟是继螨虫后的第二大过敏源','难以忍受和它共处一室','OK！拜！'],
          img: require('../../static/images/product_info/type03.jpg'),
          imgPc: require('../assets/images/pc/type03.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        },
        {
          title: '别墅除蟑螂',
          content: ['蟑螂喜暗怕光，被撞见的往往是少数','偌大的房子里，从不缺乏它们的藏身处','不要掉以轻心','OK！拜！'],
          img: require('../../static/images/product_info/type02.jpg'),
          imgPc: require('../assets/images/pc/type02.jpg'),
          okimg: require('../../static/images/okright.png'),
        },
        {
          title: '商业除蟑螂',
          content: ['流动开放的工作空间','也可能被它们悄悄占据','你或许想不到快递包裹也会携带小强','赶走不速之客，工作也要更安心','OK！拜！'],
          img: require('../../static/images/product_info/type01.jpg'),
          imgPc: require('../assets/images/pc/type01.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        }
      ],
      questionList: [
        {
          title: '用药对人和宠物安全吗？',
          content: '虫虫拜拜灭蟑服务使用的均为国际品牌正品药剂，产品本身安全环保，品质上处于行业领先水平。与此同时，我们的工程师均经过严格的理论实操培训，产品使用将严格按照说明指示规范操作，规避DIY的各种误区和不规范操作，真正免除您的安全顾虑。'
        },
        {
          title: '能确保蟑螂彻底被根除吗？',
          content: '很多人之前DIY灭蟑或许有用了药蟑螂不来吃或者稍有好转没几天蟑螂又跑出来的体验，是因为对小强的生活习性了解有限，选的产品、点施的位置、施药的密度不当导致小强实际上没有灭干净，而蟑螂的繁殖能力很强很容易反弹。虫虫拜拜工程师均经过严格专业培训，服务全程使用拜耳官方正品药剂，现场会根据现场发现的具体小强品种的习性进行规范科学的处理，从而确保见效更快、灭治更彻底。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['灭蟑螂服务（家庭）']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '检查：寻找蟑螂痕迹和滋生风险区',
              childCon: []
            },
            {
              con: '治理：隐藏式点胶布控+科学药液喷洒',
              childCon: []
            },
            {
              con: '根据现场检查处理出具专业服务报告',
              childCon: []
            }
          ]
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['单次服务预计需约45分钟-1.5小时','*具体时长随房型面积、虫害密度等情况略有浮动']
        },
        {
          title: '服务效果',
          icon: 'iconserve-reslut',
          content: ['服务当天即开始见效，快速连锁灭杀家中所有蟑螂。网格化密集布控，拒绝漏网之鱼']
        },
        {
          title: '服务保障',
          icon: 'iconserve-bz',
          content: ['<b>365天</b>ByepestCare服务保障计划。','保障期内如有发现防治靶标中所列的害虫滋生，可免费上门进行巩固处理']
        }
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用国际品牌正品药剂 安全环保'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    },
    'tiaozao': {
      id: 'fleaPlus',
      name: '跳蚤拜拜',
      iconName: 'iconn-tiaozao',
      fullname: '跳蚤无忧 快速彻底告别持久战',
      bannerImg: require('../../static/images/product_info/infobg_flea.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_flea.jpg'),
      title: '三步科学除虫',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '全面系统检查<br>揪出看不见的客人',
          content: ['根据咬痕、养宠情况等展开勘察','地毯、沙发、床垫、宠物寝具.....','不放过任何跳蚤可能藏身的角落缝隙'],
          contentTip: [],
          img: require('../../static/images/product_info/flea_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/flea_infobanner01.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '专业跳蚤清除方案<br>不留漏网之鱼',
          content: ['地毯式全面灭控','科学药液喷洒，形成持久防护膜','2次上门，双重保障灭蚤效果'],
          contentTip: [],
          img: require('../../static/images/product_info/flea_infobanner02.png'),
          imgPc: require('../assets/images/pc/product_info/flea_infobanner02.png'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '持续防控跳蚤复发<br>无忧保障灭蚤效果',
          content: ['专业服务报告，服务全程可追溯','365天ByepestCare服务保障计划','彻底告别叮咬瘙痒'],
          contentTip: [],
          img: require('../../static/images/product_info/bByepestCareTi.png'),
          imgPc: require('../assets/images/pc/product_info/bByepestCareTi.png'),
          classname: 'fontgreen',
        }
      ],
      type_list: [
        {
          title: '公寓除跳蚤',
          content: ['温暖的小窝怎能跟它共处？','小心被它吃定，咬的满身疙瘩','告别痒痒痒，要从源头上遏制','OK！拜！'],
          img: require('../../static/images/product_info/flea_type01.png'),
          imgPc: require('../assets/images/pc/product_info/flea_type01.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        },
        {
          title: '别墅除跳蚤',
          content: ['偌大的房子里，该如何彻底搞定','这些微小的烦人生物','以免漏网之鱼日后继续猖狂？','除蚤不仅要快还要彻底','OK！拜！'],
          img: require('../../static/images/product_info/flea_type02.png'),
          imgPc: require('../assets/images/pc/product_info/flea_type02.jpg'),
          okimg: require('../../static/images/okright.png'),
        },
        {
          title: '商业除跳蚤',
          content: ['自己被咬你说再忍忍？','而如果客户或员工被咬','带来的伤害和损失则容不得等待','用专业守护客户和员工的健康','OK！拜！'],
          img: require('../../static/images/product_info/flea_type03.png'),
          imgPc: require('../assets/images/pc/product_info/flea_type03.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        }
      ],
      questionList: [
        {
          title: '跳蚤治理使用的药剂对人和宠物安全吗？',
          content: '虫虫拜拜跳蚤灭治服务使用的产品均为拜耳官方正品药剂，具备三证、HACCP认证并获得WHO推荐，产品本身在安全环保品质上处于行业领先水平。与此同时，我们的工程师都经过严格的理论实操培训，产品使用都将严格按照说明指示规范操作，规避DIY的各种误区和不规范操作，真正免除您的安全顾虑。'
        },
        {
          title: '为什么需要2-3次上门？',
          content: '跳蚤的繁殖能力非常强，一只雌蚤可产200-400枚卵。因此，家中如发现跳蚤入侵，很有可能还有它的幼虫以茧的形态藏匿在家中。茧为幼虫提供了保护壳，任何除虫药剂都无法攻破，所以我们需要针对可能发生的新一轮成虫破茧而出进行巩固处理，以确保灭治彻底到位。我多次上门的费用是包含在服务费用中的，不产生额外收费。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['灭跳蚤服务（家庭）']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '检查：对室内外环境进行系统勘察分析',
              childCon: []
            },
            {
              con: '治理：根据现场选择适优药剂，精准配比，科学 药液喷洒',
              childCon: []
            },
            {
              con: '根据现场检查处理出具专业服务报告',
              childCon: []
            }
          ]
        },
        {
          title: '服务频次',
          icon: 'iconserve-no',
          content: ['2-3次上门','*具体频次视房屋结构、鼠害密度等情况或有不同，无额外收费']
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['单次服务预计需约45分钟-1.5小时','*具体时长随房型面积、虫害密度等情况略有浮动']
        },
        {
          title: '服务效果',
          icon: 'iconserve-reslut',
          content: ['快速灭杀散落藏匿在家中的所有跳蚤成虫2次上门，有效应对跳蚤茧孵化新虫双重巩固防治效果更彻底更持久']
        },
        {
          title: '服务保障',
          icon: 'iconserve-bz',
          content: ['365天ByepestCare服务保障计划','保障期内如跳蚤问题复发，可免费二次上门','<p class="smallSize" style="margin-top:5px;">*在源头（如野猫、老鼠等宿主携带进入）得到有效控制的前提下</p>']
        }
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用国际品牌正品药剂 安全环保'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    },
    'mayi': {
      id: 'antsPlus',
      name: '蚂蚁拜拜',
      iconName: 'iconn-ants',
      fullname: '蚂蚁无忧 快速精准高效只蚁不漏',
      bannerImg: require('../../static/images/product_info/infobg_ants.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_ants.jpg'),
      title: '三步科学除虫',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '按图索骥<br>探找锁定蚂蚁路径',
          content: ['根据蚂蚁习性和现场踪迹','分析食源，排摸蚁路','推拟寻找蚁巢潜在位置'],
          contentTip: [],
          img: require('../../static/images/product_info/ants_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/ants_infobanner01.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '引诱、团灭、边防<br>3重保险更彻底',
          content: ['消灭个别蚂蚁简单，灭巢才是关键','精准点胶，封堵孔缝，蚁巢灌注药液','连锁灭杀，团灭蚁群','外加边界防控，持久抵御蚂蚁入侵'],
          contentTip: [],
          img: require('../../static/images/product_info/ants_infobanner02.png'),
          imgPc: require('../assets/images/pc/product_info/ants_infobanner02.png'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '全面防控蚂蚁复现<br>持久保障灭蚁效果',
          content: ['专属虫害治理报告，全程服务可追溯','365天ByepestCare服务保障计划','持续守护，免除后顾之忧'],
          contentTip: [],
          img: require('../../static/images/product_info/bByepestCareTi.png'),
          imgPc: require('../assets/images/pc/product_info/bByepestCareTi.png'),
          classname: 'fontgreen',
        }
      ],
      type_list: [
        {
          title: '公寓除蚂蚁',
          content: ['蚂蚁污染食物，传播疾病','更是密集恐惧症患者的噩梦','它们热衷抱团，我们专注团灭','OK！拜！'],
          img: require('../../static/images/product_info/ants_type01.png'),
          imgPc: require('../assets/images/pc/product_info/ants_type01.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        },
        {
          title: '别墅除蚂蚁',
          content: ['细小的墙沿缝隙，是它们的康庄大道','一丁点的食物碎屑，也会引其入室','灭巢之余更要边界阻隔','OK！拜！'],
          img: require('../../static/images/product_info/ants_type02.png'),
          imgPc: require('../assets/images/pc/product_info/ants_type02.jpg'),
          okimg: require('../../static/images/okright.png'),
        },
        {
          title: '商业除蚂蚁',
          content: ['自己被咬你说再忍忍？','而如果客户或员工被咬','带来的伤害和损失则容不得等待','用专业守护客户和员工的健康','OK！拜！'],
          img: require('../../static/images/product_info/ants_type03.png'),
          imgPc: require('../assets/images/pc/product_info/ants_type03.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        }
      ],
      questionList: [
        {
          title: '用药对人和宠物安全吗？',
          content: '虫虫拜拜灭蚁服务使用的均为拜耳官方正品药剂，具备三证、HACCP认证并获得WHO推荐，产品本身在安全环保品质上处于行业领先水平。与此同时，我们的工程师都经过严格的理论实操培训，产品使用都将严格按照说明指示规范操作，规避DIY的各种误区和不规范操作，真正免除您的安全顾虑。'
        },
        {
          title: '能确保蚂蚁彻底被根除吗？',
          content: '消灭个别蚂蚁简单，灭巢才是关键。很多人DIY灭蚂蚁老是除不尽蚂蚁，是因为对蚂蚁的生活习性了解有限，选用的产品和方法、施药的位置没有针对性或不到位导致。蚂蚁是社会性昆虫，虫虫拜拜工程师灭蚂蚁会结合它的这一习性和活动特点，进行针对性选药用药，多管齐下，从而确保见效更快、灭治更彻底。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['灭蚂蚁服务（家庭）']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '检查：查找室内吸引源，锁定蚂蚁入侵通道和路径',
              childCon: []
            },
            {
              con: '治理：精准点胶结合药液喷洒灌注和必要封堵，围剿蚁群根据现场检查处理出具专业服务报告',
              childCon: []
            }
          ]
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['单次服务预计需约45分钟-1.5小时','*具体时长随房型面积、虫害密度等情况略有浮动']
        },
        {
          title: '服务效果',
          icon: 'iconserve-reslut',
          content: ['强效吸引蚂蚁取食，效果立竿见影。多米诺药效机理，快速从源头铲除蚁群']
        },
        {
          title: '服务保障',
          icon: 'iconserve-bz',
          content: ['365天ByepestCare服务保障计划','保障期内如蚂蚁问题未妥善解决，可免费上门进行巩固处理']
        }
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用国际品牌正品药剂 安全环保'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    },
    'laoshu': {
      id: 'ratsPlus',
      name: '老鼠拜拜',
      iconName: 'iconn-rats',
      fullname: '老鼠无忧 系统除鼠找准入侵源头',
      bannerImg: require('../../static/images/product_info/infobg_rats.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_rats.jpg'),
      title: '三步科学除鼠',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '寻找建筑结构漏洞<br>全方位追踪鼠迹',
          content: ['科学锁定鼠种类、入侵点和活动路径','粪便、脚印、尿迹、咬痕、擦痕……','凡走过必留下痕迹'],
          contentTip: [],
          img: require('../../static/images/product_info/rats_infobanner03.png'),
          imgPc: require('../assets/images/pc/product_info/rats_infobanner03.png'),
          classname: '',
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '隔堵、诱捕、施药<br>全路径系统除鼠',
          content: ['从源头阻断老鼠入侵渠道','缩小、限制老鼠活动范围','根据习性设置陷阱、诱饵，高效捕捉','精准使用拜耳鼠饵，快速降低鼠密度'],
          contentTip: [],
          img: require('../../static/images/product_info/rats_infobanner02.jpg'),
          imgPc: require('../assets/images/pc/product_info/rats_infobanner02.jpg'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '源头防控鼠害复现<br>无忧保障除鼠效果',
          content: ['专属虫害治理报告，全程服务可追溯','<b>365天</b>ByepestCare服务保障计划','持续防控，安心无忧'],
          contentTip: [],
          img: require('../../static/images/product_info/rats_infobanner01.jpg'),
          imgPc: require('../assets/images/pc/product_info/rats_infobanner01.jpg'),
          classname: 'fontgreen',
        }
      ],
      type_list: [
        {
          title: '公寓除鼠',
          content: ['老鼠狡猾敏捷，即使有限的空间里','想要将它们一网打尽也绝非易事','只有够懂它，才能赢得这场对战','OK！拜！'],
          img: require('../../static/images/product_info/rats_type01.jpg'),
          imgPc: require('../assets/images/pc/product_info/rats_type01.jpg'),
          okimg: require('../../static/images/okleftk.png')
        },
        {
          title: '别墅除鼠',
          content: ['复杂错综的建筑结构、线路管道','往往使鼠患变得更加棘手','只有够专业，才能源头解决问题','OK！拜！'],
          img: require('../../static/images/product_info/rats_type03.jpg'),
          imgPc: require('../assets/images/pc/product_info/rats_type03.jpg'),
          okimg: require('../../static/images/okright.png')
        },
        {
          title: '商业除鼠',
          content: ['鼠害威力不可小觑，不仅','危害健康卫生，还破坏经营声誉','只有够重视，业务才能健康持久','OK！拜！'],
          img: require('../../static/images/product_info/rats_type02.jpg'),
          imgPc: require('../assets/images/pc/product_info/rats_type02.jpg'),
          okimg: require('../../static/images/okleftk.png')
        }
      ],
      questionList: [
        {
          title: '老鼠为何进入室内？',
          content: '一般室内环境优渥，对老鼠来说有着丰富的食源和栖息场所，容易吸引老鼠进入。如果房屋建筑上存在缺陷漏洞、或有出入口长时间敞开，都可能为老鼠提供可乘之机。要知道，小家鼠可以钻过6mm的孔洞。此外老鼠活动能力强，而且十分聪明，有着敏锐的嗅觉、味觉和听觉，能够在建筑中迅速找到入侵通道。'
        },
        {
          title: '新建小区/高楼也会有老鼠问题？',
          content: '老鼠问题不单单是卫生的问题，它与房屋建筑结构也息息相关。不管是老小区还是新小区，低层还是高楼，都有可能遭到老鼠入侵。一些建筑在建造过程中忽略了这一点，尤其是一些高楼建筑，线路管道复杂但又没有做好封堵，使得老鼠可以在大楼之中肆意穿梭。我们服务过非常多的高楼用户，其中不乏一些知名高档小区。'
        },
        {
          title: '可以只帮忙抓老鼠吗',
          content: '虫虫拜拜提供的是系统性的鼠害解决方案，而不是单纯的捕捉老鼠。找到老鼠的入侵通道，并将其阻绝是从源头彻底解决鼠患的关键。如果只是捕捉，后续仍可能被入侵。此外，现场捉鼠亦存在偶然性，老鼠是极为机敏的生物，很有可能上门时，老鼠已暂时逃蹿到他处，甚至室外。此时就需要根据它的习性、活动路径进行封堵、隔断、诱捕，才能有效解决问题。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['灭老鼠服务（家庭）']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '检查：寻找老鼠痕迹和入侵通路',
              childCon: []
            },
            {
              con: '治理：',
              childCon: ['封堵隔断：对发现的老鼠入侵通道进行封堵隔断','诱捕：在老鼠活动路径布设粘板、捕鼠器等陷阱进行捕捉','施药：针对一些疑难杂症（如建筑结构限制作业），配合精准使用拜耳鼠剂，快速降低老鼠密度','检查： 非首次服务中对设置的陷阱进行检查，对捕获的老鼠活体/尸体妥善处置；对鼠况进行评估']
            },
            {
              con: '根据现场检查处理出具专业服务报告',
              childCon: []
            }
          ]
        },
        {
          title: '服务频次',
          icon: 'iconserve-no',
          content: ['2-3次上门','*具体频次视房屋结构、鼠害密度等情况或有不同，无额外收费']
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['首次服务预计需约1-2小时，后续跟进服务每次约0.5-1小时','*具体时长随房屋结构、鼠害密度等情况略有浮动']
        },
        {
          title: '服务保障',
          icon: 'iconserve-bz',
          content: ['<b>365天</b>ByepestCare服务保障计划。保障期内如鼠害未妥善解决，可免费二次上门']
        }
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '拜耳特殊配方，避免非靶标<br>误食，WESSA组织推荐'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    },
    'profession': {
      id: 'unknownpest2',
      name: '专业上门检测',
      iconName: 'iconspecialty',
      fullname: '未知虫害鉴定 认清身边潜在的风险',
      bannerImg: require('../../static/images/product_info/infobg_profession.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_profession.jpg'),
      title: '三步科学识虫',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '3重维度识别分析<br>不放过蛛丝马迹',
          content: ['虫体、虫迹、疑似伤害破坏……','不认识、不知道的迹象？我们来分辨','精准虫害数据库比对，锁定害虫真身'],
          contentTip: [],
          img: require('../../static/images/product_info/profession_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/profession_infobanner01.png'),
          classname: '',
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '根据环境、害虫习性<br>科学评估虫害风险',
          content: ['快速掌握害虫来源和危害情况','专业虫害鉴定报告','让你对面临的情况了如指掌'],
          contentTip: [],
          img: require('../../static/images/product_info/profession_infobanner02.jpg'),
          imgPc: require('../assets/images/pc/product_info/profession_infobanner02.jpg'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '有问题就解决<br>提供专业方案建议',
          content: ['现场沟通后续防护建议或治理方案','帮你告别这些不速之客'],
          contentTip: [],
          img: require('../../static/images/product_info/profession_infobanner03.jpg'),
          imgPc: require('../assets/images/pc/product_info/profession_infobanner03.jpg'),
          classname: 'fontgreen',
        }
      ],
      type_list: [
        {
          title: '专业识虫',
          content: ['对虫子你是不是也有脸盲症？','或是太小难以识别，更别谈从何下手','专业识虫 OK！拜！'],
          img: require('../../static/images/product_info/profession_type01.jpg'),
          imgPc: require('../assets/images/pc/product_info/profession_type01.jpg'),
          okimg: require('../../static/images/okleftk.png')
        },
        {
          title: '专业鉴定',
          content: ['它们是敌是友，从何而来？','是否已经滋生，到底有何危害？','专业鉴定 OK！拜！'],
          img: require('../../static/images/product_info/profession_type03.jpg'),
          imgPc: require('../assets/images/pc/product_info/profession_type03.jpg'),
          okimg: require('../../static/images/okright.png')
        },
        {
          title: '专业方案',
          content: ['自己尝试多种手段都难见效果','到底该怎么摆脱虫害困扰？','专业建议方案 OK！拜！'],
          img: require('../../static/images/product_info/profession_type02.jpg'),
          imgPc: require('../assets/images/pc/product_info/profession_type02.jpg'),
          okimg: require('../../static/images/okleftk.png')
        }
      ],
      questionList: [
        {
          title: '虫害鉴定是否会使用到什么黑科技？',
          content: '目前市场上并不存在可用于环境虫害监测的黑科技探照检测工具。虫虫拜拜虫害鉴定奉行的是一种科学的调查方式，该方法基于法证之父埃德蒙·罗卡的理论，旨在通过对可疑害虫留下的各种物体存留和痕迹进行查找分析，包括虫体（活体、尸体、虫卵、茧等）、虫迹（呕吐物、排泄物、脚印、擦痕、血便等）、疑似伤害破坏（木屑粉末、蛀孔、叮咬伤痕等）从而确定害虫对象及其危害情况。对于一些微小虫害，工程师在检查中会配合使用高清放大工具。'
        },
        {
          title: '我想预约虫害鉴定服务，需要做什么准备吗？',
          content: '如您有看到虫子的活体或尸体，建议保留虫体作为最直接的证据给到现场工程师鉴定分析。对于疑似虫子形成的痕迹、破坏等，也请进行妥善保护，不要自行破坏或清理。'
        },
        {
          title: '怀疑被虫子咬，但没有看到或发现虫子，可以鉴定吗？',
          content: '明确具体的虫体、虫迹无疑对鉴定最有价值。如您身上出现疑似虫咬痕迹或有被虫咬的感觉但未发现虫子，建议先及时去医院就诊，由医生判断是虫咬还是过敏，并对伤口进行妥善处理。常见的可能入侵室内的叮咬、叮蜇及可能致敏的害虫有跳蚤、蚂蚁、臭虫、蜱虫、蜘蛛、蚊虫、蜂、书虱、螨等，如您未发现相关虫体，虫虫拜拜可以结合您的症状对可疑害虫在其常见滋生地进行排查，但害虫的密度、活动性及被咬者的活动轨迹均可能对结果产生干扰或影响。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['专业虫害鉴定']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '检查：根据客户反馈对虫子虫体、虫迹、破坏等展开科学查找',
              childCon: []
            },
            {
              con: '鉴定：根据检查发现，确定虫害对象',
              childCon: []
            },
            {
              con: '评估：通过现场沟通和服务报告汇报虫害危害情况',
              childCon: []
            },
            {
              con: '方案建议：提供专业的防治建议或方案',
              childCon: []
            }
          ],
          tips: '* 如需后续治理服务，该费用不包含在鉴定费用内，需另外支付（鉴定费可在治理费用中抵扣）'
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['预计需约30-50分钟','*具体时长随房屋面积、虫害密度等情况略有浮动']
        },
        {
          title: '温馨提醒',
          icon: 'icons-tip',
          content: ['鉴定前请对虫体、疑似痕迹、破坏等进行妥善保护，如自行破坏或清理或对检查鉴定结果有影响']
        }
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '专业报告保障',
          img: require('../../static/images/iconVector.svg'),
          content: '每一次除虫服务后，都会生成专业除虫防治报告'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专属个人账户，服务全程可追溯，定期回访确保满意度'
        }
      ]
    },
    'prevention': {
      id: 'pest_prevention',
      name: '综合虫害预防',
      iconName: 'iconother',
      fullname: '综合虫害预防服务 健康环境管理',
      bannerImg: require('../../static/images/product_info/infobg_prevention.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_prevention.jpg'),
      title: '三步科学防治',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '全方位环境勘察<br>评估虫害风险等级',
          content: ['外围环境、房屋结构、湿度、卫生…','常见害虫找寻、滋生情况摸查','科学掌握居家环境的虫害抵抗力'],
          contentTip: [],
          img: require('../../static/images/product_info/prevention_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/prevention_infobanner01.png'),
          classname: '',
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '全生态系统虫控<br>将虫害消弭于无形',
          content: ['胶饵布控、边界处理、信息素…','多重手段快速灭杀已有常见害虫','消除潜藏在角落的健康隐患','建立持久有效的虫害防御屏障'],
          contentTip: [],
          img: require('../../static/images/product_info/prevention_infobanner02.jpg'),
          imgPc: require('../assets/images/pc/product_info/prevention_infobanner02.jpg'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '持续防控虫害滋生<br>长久保障环境健康',
          content: ['专属智能虫害治理报告，全程服务可溯','30天ByepestCare服务保障计划','为健康环境护航'],
          contentTip: [],
          img: require('../../static/images/product_info/prevention_infobanner03.jpg'),
          imgPc: require('../assets/images/pc/product_info/prevention_infobanner03.jpg'),
          classname: 'fontgreen',
        },
        {
          stepimg: '',
          title: '自选升级项目：+ULV空间喷雾处理',
          content: ['专业设备雾化，使药液更细致均密，深入各个角落缝隙','一键清零害虫，见效更快，防治更彻底'],
          contentTip: [],
          img: require('../../static/images/product_info/prevention_infobanner04.png'),
          imgPc: require('../assets/images/pc/product_info/prevention_infobanner04.png'),
          classname: 'fontblue',
        }
      ],
      type_list: [
        {
          title: '租房搬家做预防',
          content: ['在入住前消除新环境中','潜在的健康隐患','房子是租来的，但生活是自己的','和新住处好好相处'],
          img: require('../../static/images/product_info/prevention_type01.jpg'),
          imgPc: require('../assets/images/pc/product_info/prevention_type01.jpg'),
          okimg: require('../../static/images/okleftk.png')
        },
        {
          title: '新家入住做预防',
          content: ['开荒除虫，为新家注入虫害免疫力','不忽视生活的角落细节','给家人更细致入微的健康呵护'],
          img: require('../../static/images/product_info/prevention_type03.jpg'),
          imgPc: require('../assets/images/pc/product_info/prevention_type03.jpg'),
          okimg: require('../../static/images/okright.png')
        },
        {
          title: '定期大扫除做预防',
          content: ['大扫除时总是容易发现些不速之客','搭配深度保洁进行综合防治','虫害灭治更彻底，效果更持久'],
          img: require('../../static/images/product_info/prevention_type02.jpg'),
          imgPc: require('../assets/images/pc/product_info/prevention_type02.jpg'),
          okimg: require('../../static/images/okleftk.png')
        }
      ],
      questionList: [
        {
          title: '用药对人和宠物安全吗？',
          content: '虫虫拜拜服务使用的均为拜耳官方正品药剂，具备三证、HACCP认证并获得WHO推荐，产品本身在安全环保品质上处于行业领先水平。与此同时，我们的工程师都经过严格的理论实操培训，产品使用都将严格按照说明指示规范操作，规避DIY的各种误区和不规范操作，真正免除您的安全顾虑。'
        },
        {
          title: '综合虫害预防防治靶标包括哪些？',
          content: '本服务覆盖家庭常见的滋扰害虫和卫生害虫，包括蟑螂、蚂蚁、厨卫飞虫（蛾蚋、果蝇、蚤蝇等）、潮湿害虫（书虱、跳虫、薪甲等）、织物害虫（衣蛾、皮蠹等）、仓储害虫（锯谷盗、谷象、烟草甲等）、马蜂和蜘蛛、蚰蜒、马陆、蜈蚣等偶然入侵害虫。（如需白蚁、老鼠、蛀木害虫和飞虫类防治服务，请咨询我们的在线顾问）。'
        },
        {
          title: '家里已经发现明显虫害滋生，譬如蟑螂，适合做综合预防吗？',
          content: '如果已经发现明确的问题症结，建议选择更有针对性的专项灭治服务，处理会更深入彻底，对应的ByepestCare服务保障计划也更长，报告也可以给到您更有针对性的建议。综合预防更适合搬入新环境时或搭配全面大扫除进行，未雨绸缪，从而为环境提供更加长久的防护。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['综合虫害预防服务']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '环境勘察，评估现场虫害风险',
              childCon: []
            },
            {
              con: '系统综合治理：<br>基础版：胶饵布控+信息素诱捕+药液边界处理<br>升级版：+ULV空间喷雾处理',
              childCon: []
            },
            {
              con: '根据现场检查处理出具专业服务报告',
              childCon: []
            }
          ]
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['单次服务预计需约1-1.5小时','*具体时长视房屋面积、虫害情况略有浮动']
        },
        {
          title: '服务次数',
          icon: 'icons-count',
          content: ['基础版含1次常规上门服务','升级版含2次常规上门服务']
        },
        {
          title: '服务保障',
          icon: 'iconserve-bz',
          content: ['30天ByepestCare服务保障计划。','保障期内如有发现防治靶标中所列的害虫滋生，可免费上门进行巩固处理']
        },
        {
          title: '推荐频次',
          icon: 'iconserve-no',
          content: ['每年1-2次']
        }
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用国际品牌正品药剂 安全环保'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专属个人账户，服务全程可追溯，定期回访确保满意度'
        }
      ]
    },
    'baiyiyufang': {
      id: 'white_ant_precaution',
      name: '白蚁预防',
      iconName: 'iconwhite_ant_prevent',
      fullname: '白蚁预防 专业长效呵护房屋安全',
      bannerImg: require('../../static/images/product_info/infobg_baiyiyufang.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_baiyiyufang.jpg'),
      title: '三步科学防治',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '由外及内全面排查<br>白蚁入侵风险',
          content: ['根据白蚁习性全方位勘察环境','结合外围环境、楼层、结构、湿度……','综合评估白蚁感染风险和风险区域'],
          contentTip: [],
          img: require('../../static/images/product_info/baiyiyufang_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/baiyiyufang_infobanner01.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '量身定制<br>专业解决方案',
          content: ['装修房根据装修进度进行无创喷洒处理','成品房据勘察情况制定微创防治方案','最大程度保护房屋结构完整性','持久抵御白蚁入侵'],
          contentTip: [],
          img: require('../../static/images/product_info/baiyiyufang_infobanner02.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyiyufang_infobanner02.jpg'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '金钟罩持续防控<br>科学保障除蚁效果',
          content: ['可提供长达3年的ByepestCare服务保障计划','专业服务报告，专属客户档案','服务全程可追溯'],
          contentTip: [],
          img: require('../../static/images/product_info/baiyiyufang_infobanner03.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyiyufang_infobanner03.jpg'),
          classname: 'fontgreen',
        }
      ],
      // swipe_list: [
      //   {
      //     stepimg: '',
      //     title: '<span class="tit">处理手段</span><br><span class="point"></span>Termidor喷洒灌注',
      //     content: ['采用拜耳官方产品Termidor，独有专利技术','深入房屋缝隙直击蚁害源头，给生活空间形成长期蚁害免疫力'],
      //     img: require('../../static/images/product_info/baiyiyufang_infobanner04.png'),
      //     imgPc: require('../assets/images/pc/product_info/baiyiyufang_infobanner04.png'),
      //     classname: 'fontblue',
      //     cricle: {
      //       isLeft: false,
      //       isTop: true,
      //       x: '30px',
      //       y: '60px',
      //       color: '#AACC03'
      //     },
      //     point: {
      //       isLeft: true,
      //       isTop: false,
      //       x: '88px',
      //       y: '-40px',
      //       color: '#AACC03'
      //     }
      //   },
      //   {
      //     stepimg: '',
      //     title: '<span class="tit">处理手段</span><br><span class="point"></span>Exterra白蚁诱饵系统',
      //     content: ['采用全球第一的Exterra白蚁诱饵系统','更适用于室外土壤处理，快速消灭房屋周围白蚁，阻断白蚁入侵步伐'],
      //     img: require('../../static/images/product_info/baiyiyufang_infobanner05.png'),
      //     imgPc: require('../assets/images/pc/product_info/baiyiyufang_infobanner05.png'),
      //     classname: 'fontblue',
      //     cricle: {
      //       isLeft: false,
      //       isTop: true,
      //       x: '30px',
      //       y: '60px',
      //       color: '#00BCFF'
      //     },
      //     point: {
      //       isLeft: true,
      //       isTop: false,
      //       x: '88px',
      //       y: '-40px',
      //       color: '#00BCFF'
      //     }
      //   }
      // ],
      type_list: [
        {
          title: '不要掉以轻心',
          content: ['如果你周围有人家正在被白蚁侵袭','如果你见识过春夏扑面而来的白蚁群','请不要抱有侥幸心理'],
          img: require('../../static/images/product_info/baiyiyufang_type01.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyiyufang_type01.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        },
        {
          title: '为爱家上份保险',
          content: ['抵御白蚁最好的办法就是未雨绸缪','不让装修投入的心力白费','让房屋在白蚁来袭时固若金汤'],
          img: require('../../static/images/product_info/baiyiyufang_type02.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyiyufang_type02.jpg'),
          okimg: require('../../static/images/okright.png'),
        },
        {
          title: '相信科学专业',
          content: ['用科学为品质护航','你的家值得最好的呵护','房屋大事交给放心的人'],
          img: require('../../static/images/product_info/baiyiyufang_type03.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyiyufang_type03.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        }
      ],
      questionList: [
        {
          title: '白蚁治理使用的药剂对人和宠物安全吗？',
          content: '虫虫拜拜白蚁灭治服务使用的产品均为国际知名产品，产品本身在安全环保品质上处于行业领先水平。与此同时，我们的工程师都经过严格的理论实操培训，产品使用都将严格按照说明指示规范操作，规避DIY的各种误区和不规范操作，真正免除您的安全顾虑。'
        },
        {
          title: '什么情况下建议做白蚁预防？',
          content: '白蚁以木材为食，且水源对白蚁的生活至关重要，所以周围绿化较好、气候湿润的南方地区普遍容易遭受白蚁侵袭。如果您正在装修，不忍精心挑选的木材之后被白蚁破坏，或是小区周边住户有白蚁侵扰的历史，或自己家曾经被白蚁困扰多年，现在下定决心重新装修，建议可以通过白蚁预防处理长效抵御白蚁。此外，除了每年春夏的分飞入侵，白蚁通常还以修筑蚁道从土壤入侵，因此，别墅和位于底层的住宅也更容易被白蚁攻击，需要更加警惕。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['白蚁预防（勘察）']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '全面勘察：对室内外环境及建筑结构等情况进行系统勘察分析',
              childCon: []
            },
            {
              con: '专业方案：根据勘察结果和房屋装修进度制定科学的防治方案',
              childCon: []
            },
            {
              con: '后续治理：若客户确认和接受方案和费用，将根据方案展开预防处理',
              childCon: []
            },
            {
              con: '服务报告：每次现场处理都有相应的服务报告记录<p class="smallSize" style="margin-top:5px;">* 本服务为勘察制定方案和报价的费用，如需后续治理服务，需另外支付。具体费用明细将在方案提报中列明（勘察费用可在治理费用中抵扣）</p>',
              childCon: []
            }
          ]
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['勘察预计需约30-50分钟','*具体时长随房屋面积、虫害密度等情况略有浮动']
        }
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用国际品牌正品药剂 安全环保'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    },
    'baiyikancha': {
      id: 'white_ant_check',
      name: '白蚁灭治',
      iconName: 'iconwhite_ant_check',
      fullname: '白蚁灭治 严格品控专业正规长效',
      bannerImg: require('../../static/images/product_info/infobg_baiyikancha.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_baiyikancha.jpg'),
      title: '三步科学除虫',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '全空间白蚁勘察<br>科学评估蚁害风险',
          content: ['全面了解摸查室内外环境','根据发现白蚁的时间、形态、痕迹、数量…','快速锁定白蚁种类，评估白蚁危害风险等级'],
          contentTip: [],
          img: require('../../static/images/product_info/baiyikancha_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/baiyikancha_infobanner01.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '涟漪式微创治理<br>源头灭白蚁',
          content: ['为客户实施最合适的微创治理方案','消灭蚁后，灭除蚁巢','治理完成后修补复原微创孔洞','长效防护 安全健康无忧'],
          contentTip: [],
          img: require('../../static/images/product_info/baiyikancha_infobanner02.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyikancha_infobanner02.jpg'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '持续防控白蚁滋生<br>长久保障房屋安全',
          content: ['专属专业服务报告 全程服务可追溯','可提供长达3年的定点白蚁防控服务','诱饵站方案 定期监测灭除进度'],
          contentTip: [],
          img: require('../../static/images/product_info/baiyikancha_infobanner03.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyikancha_infobanner03.jpg'),
          classname: 'fontgreen',
        }
      ],
      // swipe_list: [
      //   {
      //     stepimg: '',
      //     title: '<span class="tit">可选方案</span><br><span class="point"></span>Termidor喷洒灌注',
      //     content: ['采用拜耳官方产品Termidor，独有专利技术','深入房屋缝隙直击蚁害源头，给生活空间形成长期蚁害免疫力'],
      //     img: require('../../static/images/product_info/baiyikancha_infobanner04.png'),
      //     imgPc: require('../assets/images/pc/product_info/baiyikancha_infobanner04.png'),
      //     classname: 'fontblue',
      //     cricle: {
      //       isLeft: false,
      //       isTop: true,
      //       x: '30px',
      //       y: '60px',
      //       color: '#AACC03'
      //     },
      //     point: {
      //       isLeft: true,
      //       isTop: false,
      //       x: '88px',
      //       y: '-40px',
      //       color: '#AACC03'
      //     }
      //   },
      //   {
      //     stepimg: '',
      //     title: '<span class="tit">可选方案</span><br><span class="point"></span>Exterra白蚁诱饵系统',
      //     content: ['采用全球第一的Exterra白蚁诱饵系统','快速灭白蚁，可视化强，灭巢于无形'],
      //     img: require('../../static/images/product_info/baiyikancha_infobanner05.png'),
      //     imgPc: require('../assets/images/pc/product_info/baiyikancha_infobanner05.png'),
      //     classname: 'fontblue',
      //     cricle: {
      //       isLeft: false,
      //       isTop: true,
      //       x: '30px',
      //       y: '60px',
      //       color: '#00BCFF'
      //     },
      //     point: {
      //       isLeft: true,
      //       isTop: false,
      //       x: '88px',
      //       y: '-40px',
      //       color: '#00BCFF'
      //     }
      //   }
      // ],
      type_list: [
        {
          title: '正确认识白蚁',
          content: ['以为只有老房子、低楼层有白蚁？','实际它可以飞上32层的高楼筑巢','白蚁不是会飞的蚂蚁','它对建筑装潢的危害不容小觑'],
          img: require('../../static/images/product_info/baiyikancha_type01.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyikancha_type01.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        },
        {
          title: '科学除白蚁',
          content: ['用喷雾罐喷，用开水烫？','土法子反而可能促使白蚁扩散','真正专业的人员和手段，才能让你无忧'],
          img: require('../../static/images/product_info/baiyikancha_type02.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyikancha_type02.jpg'),
          okimg: require('../../static/images/okright.png'),
        },
        {
          title: '正规除白蚁',
          content: ['专业化方案报价，官方正规用药','严格品控，规范透明','房屋大事交给放心的人'],
          img: require('../../static/images/product_info/baiyikancha_type03.jpg'),
          imgPc: require('../assets/images/pc/product_info/baiyikancha_type03.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        }
      ],
      questionList: [
        {
          title: '白蚁治理使用的药剂对人和宠物安全吗？',
          content: '虫虫拜拜白蚁灭治服务使用的产品均为国际知名产品，产品本身在安全环保品质上处于行业领先水平。与此同时，我们的工程师都经过严格的理论实操培训，产品使用都将严格按照说明指示规范操作，规避DIY的各种误区和不规范操作，真正免除您的安全顾虑。'
        },
        {
          title: '什么情况下建议做白蚁预防？',
          content: '白蚁以木材为食，且水源对白蚁的生活至关重要，所以周围绿化较好、气候湿润的南方地区普遍容易遭受白蚁侵袭。如果您正在装修，不忍精心挑选的木材之后被白蚁破坏，或是小区周边住户有白蚁侵扰的历史，或自己家曾经被白蚁困扰多年，现在下定决心重新装修，建议可以通过白蚁预防处理长效抵御白蚁。此外，除了每年春夏的分飞入侵，白蚁通常还以修筑蚁道从土壤入侵，因此，别墅和位于底层的住宅也更容易被白蚁攻击，需要更加警惕。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['白蚁灭治（勘察）']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '检查：对现场环境及白蚁感染情况进行系统勘察',
              childCon: []
            },
            {
              con: '鉴定：确定可能的白蚁种类和危害风险等级',
              childCon: []
            },
            {
              con: '专业方案：根据检查结果制定科学防治方案，1-3年ByepestCare服务保障计划可供选择',
              childCon: []
            },
            {
              con: '后续治理：若客户确认和接受方案和费用，将根据方案展开灭巢治理',
              childCon: []
            },
            {
              con: '服务报告：每次现场处理都有相应的服务报告记录<p class="smallSize" style="margin-top:5px;">* 本服务为勘察制定方案和报价的费用，如需后续治理服务，需另外支付。具体费用明细将在方案提报中列明（勘察费用可在治理费用中抵扣）</p>',
              childCon: []
            }
          ]
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['勘察预计需约30-50分钟','*具体时长随房屋面积、虫害密度等情况略有浮动']
        },
        {
          title: '温馨提醒',
          icon: 'icons-tip',
          content: [
            {
              con: '勘察前请对虫体、疑似痕迹、破坏等进行妥善保护',
              childCon: []
            },
            {
              con: '请勿擅自用杀虫喷雾等对白蚁进行大范围喷杀，以免破坏其活动路径',
              childCon: []
            }
          ]
        }
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用拜耳官方正品药剂和国际知名品牌产品'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    },
    'bieshu-beifen': {
      id: 'pest_management',
      name: '综合虫害管家服务',
      iconName: 'iconvillas',
      fullname: '百虫无忧-全年无虫 健康无忧',
      bannerImg: require('../../static/images/product_info/infobg_bieshu.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_bieshu.jpg'),
      title: '德国拜耳守护 全年安心无忧',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '60+种常见害虫<br>定期巡检监测',
          content: ['每季度全靶标虫害巡检','根据环境和害虫习性','科学排查潜在虫害风险','稳固维护家庭虫害抵抗力'],
          contentTip: [],
          img: require('../../static/images/product_info/bieshu_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/bieshu_infobanner01.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '科学方案部署<br>全生态系统防治',
          content: ['5次基础上门 全方位防治布控','漏洞封堵、胶饵布控、','空间喷雾、信息素…','多重手段精准打击，强效灭控害虫','打造全空间虫害防御屏障'],
          contentTip: [],
          img: require('../../static/images/product_info/bieshu_infobanner02.png'),
          imgPc: require('../assets/images/pc/product_info/bieshu_infobanner02.png'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '管家式响应管理<br>持续保障环境健康',
          content: ['365天ByepestCare服务保障计划','1V1专属虫害顾问持续跟进','专属服务通道急速响应 随叫随到','优先安排资深工程师上门'],
          contentTip: [],
          img: require('../../static/images/product_info/bByepestCareTi.png'),
          imgPc: require('../assets/images/pc/product_info/bByepestCareTi.png'),
          classname: 'fontgreen',
        }
      ],
      type_list: [],
      chonghaiList: [
        {
          iconName: 'iconn-ants',
          left: '47%',
          bottom: '24%',
          name: '蚂蚁',
          content: '易被香甜食物吸引，喜欢结队而来。蚂蚁也会污染食物，传播疾病；有些品种还会咬人，引发过敏'
        },
        {
          iconName: 'iconn-cangchu',
          left: '72%',
          bottom: '37%',
          name: '仓储害虫',
          content: '锯谷盗、米象、烟草甲、印度谷斑螟等害虫会感染食物，造成食物发霉变味，甚至传播细菌病毒'
        },
        {
          iconName: 'iconn-cockroach',
          left: '63%',
          bottom: '28%',
          name: '蟑螂',
          content: '别墅空间大，食源丰富，利于蟑螂滋生藏匿。蟑螂会污染食物，传染疾病，其产生的过敏原是儿童哮喘的主要诱因'
        },
        {
          iconName: 'iconn-rats',
          left: '27%',
          bottom: '60%',
          name: '老鼠',
          content: '别墅建筑复杂，给老鼠提供了很多可乘之机。阁楼、地下室等处是高发地。老鼠会破坏物品，污染食物，传染疾病'
        },
        {
          iconName: 'iconn-huayuan',
          left: '4%',
          bottom: '15%',
          name: '花园害虫',
          content: '花园草坪可能滋生蜘蛛、蛞蝓、蜗牛、蜈蚣、马陆等系列害虫。对生活健康带来不必要的滋扰和风险'
        },
        {
          iconName: 'iconn-zhiwu',
          left: '20%',
          bottom: '37%',
          name: '织物害虫',
          content: '衣柜/地毯里可能滋生衣蛾、皮蠹，它们喜欢以天然蛋白质为食，会破坏羊毛、丝绸、皮革等材料'
        },
        {
          iconName: 'iconn-feichong',
          left: '33%',
          bottom: '14%',
          name: '夏季飞虫',
          content: '夏季升温，各种小飞虫随之增加，尤其是蚊子，常常把人咬得浑身是包，不仅奇痒难忍还可能传播多种疾病'
        },
        {
          iconName: 'iconn-chaoshi',
          left: '55%',
          bottom: '61%',
          name: '潮湿害虫',
          content: '地下室、储物间、洗衣间等潮湿位置可能滋生书虱、跳虫、薪甲等。这些害虫喜欢食用真菌，会对书籍、织物等造成危害'
        },
        {
          iconName: 'iconn-tiaozao',
          left: '78%',
          bottom: '25%',
          name: '跳蚤',
          content: '别墅外围常有流浪猫狗、野生动物出入，或将跳蚤携带进入家中。跳蚤叮咬会导致过敏瘙痒，或传染血液传播疾病'
        },
      ],
      questionList: [
        {
          title: '用药对人和宠物安全吗？',
          content: '虫虫拜拜灭蟑服务使用的均为国际品牌正品药剂，产品本身安全环保，品质上处于行业领先水平。与此同时，我们的工程师均经过严格的理论实操培训，产品使用将严格按照说明指示规范操作，规避DIy的各种误区和不规范操作，真正免除您的安全顾虑。'
        },
        {
          title: '别墅为什么要做虫害综合服务？',
          content: '别墅外围环境较为复杂，大多有草坪、绿化等，容易滋生各种虫害问题。此外，别墅建筑体面积大，建筑相对复杂，存在较多的孔洞和出入口，给各种害虫提供了可乘之机，阔大的空间和复杂的建筑环境、装修等也给害虫们提供了诸多躲藏栖息的场所。有些区域长期处于无人看管打理的状态，如地下室、阁楼、储藏室等，更是容易成为老鼠、蟑螂等害虫的滋生地。很多害虫会对人的正常生活带来滋扰和危害，有些甚至未被察觉。譬如蟑螂、老鼠等害虫，可能会污染食物，传播疾病；一些害虫则会咬人蜇人，引发过敏、瘙痒等症状。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['综合虫害管家服务']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '每季度一次全方位综合虫害检查处理：',
              childCon: ['环境勘察，评估现场虫害风险','系统综合治理：根据检查发现综合使用胶饵布控、信息素诱捕、药液边界处理、ULV空间喷雾处理、绿篱喷洒、水体孑孓控制等手段对虫害进行控制','根据现场检查处理出具专业服务报告']
            },
            {
              con: '管家式点对点定期跟进和响应服务',
              childCon: []
            },
          ]
        },
        {
          title: '服务频次',
          icon: 'iconserve-no',
          content: ['服务周期12个月，5次常规上门服务，首月2次，后续每季度1次，总服务次数无限制，服务期内专属顾问密切跟进']
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['每次服务时间预计需约1-1.5小时','*具体时长随房屋面积、虫害密度等情况略有浮动']
        },
        {
          title: '服务效果',
          icon: 'iconserve-reslut',
          content: ['快速灭杀别墅室内已有入侵害虫，构建整体虫害防御体系，将别墅可能存在的多种虫害风险降到最低']
        },
        {
          title: '服务保障',
          icon: 'iconserve-bz',
          content: ['<b>365天</b>ByepestCare服务保障计划。期间如需额外的跟进服务，我们将优先派遣资深工程师，免费上门提供']
        },
        {
          title: '防治靶标',
          icon: 'iconbabiao',
          content: ['本服务涵盖蟑螂、老鼠、蚂蚁、跳蚤、臭虫等各类常见卫生害虫、滋扰害虫，以及各类厨卫飞虫（蛾蚋、果蝇、蚤蝇等）、潮湿害虫（书虱、跳虫、薪甲等）、织物害虫（衣蛾、皮蠹等）、仓储害虫（锯谷盗、谷象、烟草甲等）、马蜂和蜘蛛、蚰蜒、马陆、蜈蚣等偶然入侵害虫。白蚁、蚊虫服务详情请咨询在线顾问。']
        },
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用国际品牌正品药剂 安全环保'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    },
    'bieshu': {
      id: 'pest_management',
      name: '百虫无忧',
      iconName: 'iconvillas',
      fullname: '百虫无忧-全年无虫 健康无忧',
      bannerImg: require('../../static/images/product_info/infobg_bieshu.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_bieshu.jpg'),
      title: '德国拜耳守护 全年安心无忧',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '全屋综合虫害风险勘查<br>覆盖108种常见害虫',
          content: ['根据环境和害虫习性','科学排查潜在虫害风险','稳固维护家庭虫害抵抗力'],
          contentTip: [],
          img: require('../../static/images/product_info/bieshu_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/bieshu_infobanner01.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '科学方案部署<br>全生态系统防治',
          content: ['根据检查发现综合采用','胶饵布控、信息素诱捕、','滞留喷洒、边界防控','多重手段精准打击，强效灭控害虫','构建全空间虫害防御屏障'],
          contentTip: [],
          img: require('../../static/images/product_info/bieshu_infobanner02.png'),
          imgPc: require('../assets/images/pc/product_info/bieshu_infobanner02.png'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '管家式响应管理<br>持续保障环境健康',
          content: ['365天ByepestCare服务保障计划','1V1专属虫害顾问持续跟进','专属服务通道急速响应 随叫随到','优先安排资深工程师上门'],
          contentTip: [],
          img: require('../../static/images/product_info/bByepestCareTi.png'),
          imgPc: require('../assets/images/pc/product_info/bByepestCareTi.png'),
          classname: 'fontgreen',
        }
      ],
      type_list: [],
      type2_list: [
        {
          title: '专业工程师团队',
          content: ['这是一群热衷研究虫子的Geek，他们深谙虫子的习性、优质的产品，让除虫这件麻烦事儿事半功倍','平台统一选拔招募','系统专业课程培训'],
          img: require('../../static/images/product_info/pest_type01.jpg'),
          imgPc: require('../assets/images/pc/product_info/pest_type03.png'),
          okimg: require('../../static/images/okLeftPest.png'),
        },
        {
          title: '专业品质 科学除虫',
          content: ['传承500强百年对品质的苛求理念','优质产品搭配科学的解决方案'],
          img: require('../../static/images/product_info/pest_type02.jpg'),
          imgPc: require('../assets/images/pc/product_info/pest_type01.png'),
          okimg: require('../../static/images/okRightPest.png'),
        },
        {
          title: '医学级安全 健康无忧',
          content: ['全程使用国际品牌正品药剂','规范安全的SOP，精准配比用药'],
          img: require('../../static/images/product_info/pest_type03.jpg'),
          imgPc: require('../assets/images/pc/product_info/pest_type02.png'),
          okimg: require('../../static/images/okLeftPest.png'),
        }
      ],
      chonghaiList: [],
      questionList: [
        {
          title: '用药对人和宠物安全吗？',
          content: '虫虫拜拜灭蟑服务使用的均为国际品牌正品药剂，产品本身安全环保，品质上处于行业领先水平。与此同时，我们的工程师均经过严格的理论实操培训，产品使用将严格按照说明指示规范操作，规避DIy的各种误区和不规范操作，真正免除您的安全顾虑。'
        },
        {
          title: '别墅为什么要做虫害综合服务？',
          content: '别墅外围环境较为复杂，大多有草坪、绿化等，容易滋生各种虫害问题。此外，别墅建筑体面积大，建筑相对复杂，存在较多的孔洞和出入口，给各种害虫提供了可乘之机，阔大的空间和复杂的建筑环境、装修等也给害虫们提供了诸多躲藏栖息的场所。有些区域长期处于无人看管打理的状态，如地下室、阁楼、储藏室等，更是容易成为老鼠、蟑螂等害虫的滋生地。很多害虫会对人的正常生活带来滋扰和危害，有些甚至未被察觉。譬如蟑螂、老鼠等害虫，可能会污染食物，传播疾病；一些害虫则会咬人蜇人，引发过敏、瘙痒等症状。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['综合虫害管家服务']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '全屋综合虫害风险勘查，科学评估现场环境',
              childCon: []
            },
            {
              con: '108虫全虫种系统综合防治：根据检查发现综合使用胶饵布控、信息素诱捕、滞留喷洒、边界防控等多重手段精准打击，强效灭控害虫。',
              childCon: []
            },
            {
              con: '根据现场检查处理出具专业服务报告',
              childCon: []
            },
            {
              con: '365天ByepestCare服务；管家式1V1定期跟进和响应服务',
              childCon: []
            },
          ]
        },
        {
          title: '服务频次',
          icon: 'iconserve-no',
          content: ['12个月维护期，别墅用户含4次常规上门服务(每季度1次);公寓用户含1次常规上门服务。<br>365天维护期内，服务范畴内任何虫害问题复发，用户可享受免费维护服务。']
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['每次服务时间预计需约1-2小时','*具体时长随房屋面积、虫害密度等情况略有浮动']
        },
        {
          title: '服务效果',
          icon: 'iconserve-reslut',
          content: ['365天ByepestCare服务保障计划。快速灭杀已有入侵害虫，构建整体虫害防御体系，将可能存在的多种虫害风险降到最低，减少环境中的变应原，提升环境健康免疫力']
        },
        {
          title: '服务范围',
          icon: 'iconbabiao',
          content: ['本服务涵盖家庭室内108种家庭常见病媒生物、卫生滋扰害虫，包括蟑螂、蚂蚁、跳蚤、臭虫、蜱虫、革螨、各类厨卫飞虫（蛾蚋、果蝇、蚤蝇等）、潮湿害虫（书虱、跳虫、薪甲等）、织物害虫（衣蛾、皮蠹等）、仓储害虫（锯谷盗、谷象、烟草甲等）、肿腿蜂、马蜂、蜘蛛、蚰蜒、马陆、蜈蚣等偶然入侵害虫的防治。','- 赠送白蚁勘察服务1次。','- 别墅用户赠送蚊虫拜拜服务1次。']
        },
      ],
      sixEnsureList: []
    },
    'feichong': {
      id: 'mosquito',
      name: '蚊虫拜拜',
      iconName: 'iconn-feichong',
      fullname: '蚊虫拜拜 这个夏天告别叮咬',
      bannerImg: require('../../static/images/product_info/infobg_feichong.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_feichong.jpg'),
      title: '三步科学除虫',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '全方位环境勘察<br>锁定飞虫滋生源',
          content: ['室内外全空间飞虫密度快速评估','根据飞虫习性（蚊虫为主）','对灌木、草坪、水体等易滋生隐藏区','进行深入勘察了解'],
          contentTip: [],
          img: require('../../static/images/product_info/feichong_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/feichong_infobanner01.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '“海陆空”多管齐下<br>快速见效 持久防控',
          content: ['根据飞虫习性量身定制方案','水体孑孓控制有效控制蚊虫繁殖','蚊虫栖身处精准快速灭杀','绿篱处理技术，长效防护'],
          contentTip: [],
          img: require('../../static/images/product_info/feichong_infobanner02.png'),
          imgPc: require('../assets/images/pc/product_info/feichong_infobanner02.png'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '点对点持续防控<br>科学保障控虫效果',
          content: ['持久药效——看不见的角落持续防控','专业服务报告，服务全程可追溯','免除你的后顾之忧'],
          contentTip: [],
          img: require('../../static/images/product_info/feichong_infobanner03.png'),
          imgPc: require('../assets/images/pc/product_info/feichong_infobanner03.png'),
          classname: 'fontgreen',
        }
      ],
      type_list: [
        {
          title: '不再惧怕虫咬',
          content: ['TA的秘密是什么?','为什么TA可以悠然地','和家人在花园漫步，在露台乘凉?','这个夏天，告别虫咬','OK！拜！'],
          img: require('../../static/images/product_info/feichong_type01.jpg'),
          imgPc: require('../assets/images/pc/product_info/feichong_type01.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        },
        {
          title: '更尽地主之谊',
          content: ['邀好友欣赏精心打理的庭院','来一场户外烤肉，恼人的蚊虫','却可能轻而易举让宾客败兴而归','赶走蚊虫，更尽地主之谊','OK！拜！'],
          img: require('../../static/images/product_info/feichong_type02.jpg'),
          imgPc: require('../assets/images/pc/product_info/feichong_type02.jpg'),
          okimg: require('../../static/images/okright.png'),
        },
        {
          title: '健康生活新方式',
          content: ['家人的健康安全上，没有小事','蚊虫虽小危害却大，咬上一口','不仅奇痒难忍，还可能传播疾病','再微小的角落，也有拜耳守护','OK！拜！'],
          img: require('../../static/images/product_info/feichong_type03.jpg'),
          imgPc: require('../assets/images/pc/product_info/feichong_type03.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        }
      ],
      questionList: [
        {
          title: '飞虫治理使用的药剂对人和宠物安全吗？',
          content: '虫虫拜拜飞虫灭治服务使用的产品均为拜耳官方正品药剂，具备三证、HACCP认证并获得WHO推荐，产品本身在安全环保品质上处于行业领先水平。与此同时，我们的工程师都经过严格的理论实操培训，产品使用都将严格按照说明指示规范操作，现场给予你规范科学的引导，规避DIY的各种误区，真正免除您的安全顾虑。'
        },
        {
          title: '天气不好如遇上下雨天，会对服务造成影响吗？',
          content: '服务当日，在对外围环境进行处理时建议避开阴雨天，以免对操作带来干扰。而服务完成后，基于绿篱技术等科学手段的采用（针对绿植背面进行喷洒），服务滞留的药剂能有效地抵御降雨的冲刷和破坏，仍旧维持非常长的一段时间，持续防控蚊虫滋生。如果服务当天下雨，后台客服专员会与您协调顺延服务时间，保证最佳的服务效果。'
        }
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['蚊虫控制服务']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '检查：对室内外环境进行勘察分析',
              childCon: []
            },
            {
              con: '治理：根据现场选择适优药剂，综合使用孑孓控制、滞留喷洒、绿篱处理、ULV空间喷雾处理等处理手段进行飞虫灭控',
              childCon: []
            },
            {
              con: '根据现场检查处理出具专业服务报告',
              childCon: []
            },
          ]
        },
        {
          title: '服务频次',
          icon: 'iconserve-no',
          content: ['1月2次，每2周1次常规服务']
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['单次服务预计需约45分钟-1.5小时','*具体时长随房型面积、虫害密度等情况略有浮动']
        },
        {
          title: '服务效果',
          icon: 'iconserve-reslut',
          content: ['快速灭杀防控区已有蚊虫，现场灭杀率达100%。','有效控制源头，持久防控。一次处理可以保障您的院落未来21天内的蚊虫密度控制在极低水平。']
        },
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用国际品牌正品药剂 安全环保'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，数字化平台<br>快速响应，全方位服务支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    },
    'paidui': {
      id: 'party_prepair',
      name: '派对活动准备',
      iconName: 'iconparty',
      fullname: '派对活动紧急控蚊服务',
      bannerImg: require('../../static/images/product_info/infobg_paidui.jpg'),
      bannerImgPc: require('../assets/images/pc/product_info/infobg_paidui.jpg'),
      title: '三步科学除虫',
      stepList: [
        {
          stepimg: require('../../static/images/step1.svg'),
          title: '快速环境勘察<br>制定最佳处理方案',
          content: ['室内外全空间飞虫密度快速评估','根据飞虫习性和现场环境','制定最佳处理方案'],
          contentTip: [],
          img: require('../../static/images/product_info/paidui_infobanner01.png'),
          imgPc: require('../assets/images/pc/product_info/paidui_infobanner01.png'),
        },
        {
          stepimg: require('../../static/images/step2.svg'),
          title: '全空间高效灭控<br>快速灭蚊无死角',
          content: ['采用全空间ULV空间喷雾处理','WHO推荐产品，30分钟速干，无色无味','结合水体孑孓控制、滞留喷洒','现场蚊虫灭杀率达99.9%'],
          contentTip: [],
          img: require('../../static/images/product_info/paidui_infobanner02.png'),
          imgPc: require('../assets/images/pc/product_info/paidui_infobanner02.png'),
          classname: 'fontblue',
        },
        {
          stepimg: require('../../static/images/step3.svg'),
          title: '持久防御保障<br>整场活动无忧',
          content: ['持久药效防控 保障派对活动','全程免受蚊虫叮咬骚扰','蚊虫黔驴技穷，宾客乐而忘返'],
          contentTip: [],
          img: require('../../static/images/product_info/paidui_infobanner03.png'),
          imgPc: require('../assets/images/pc/product_info/paidui_infobanner03.png'),
          classname: 'fontgreen',
        }
      ],
      type_list: [
        {
          title: '如果你有一场草坪婚礼',
          content: ['别让蚊子破坏了现场的美好浪漫','在新人和宾客身上','留下并不甜蜜的亲吻','急速控蚊，让浪漫没有打扰'],
          img: require('../../static/images/product_info/paidui_type01.jpg'),
          imgPc: require('../assets/images/pc/product_info/paidui_type01.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        },
        {
          title: '如果你是Party爱好者',
          content: ['别让蚊子坏了大家的兴致','没有了舞蹈，眼前的BBQ也不香了只有啪啪啪徒手灭蚊的烦恼','急速控蚊，让活动更尽兴'],
          img: require('../../static/images/product_info/paidui_type02.jpg'),
          imgPc: require('../assets/images/pc/product_info/paidui_type02.jpg'),
          okimg: require('../../static/images/okright.png'),
        },
        {
          title: '如果你是活动承办商',
          content: ['别让蚊子成为整场活动的污点','给客户留下不好的体验和印象','细节更能凸显品质','急速控蚊，让客户更满意'],
          img: require('../../static/images/product_info/paidui_type03.jpg'),
          imgPc: require('../assets/images/pc/product_info/paidui_type03.jpg'),
          okimg: require('../../static/images/okleftk.png'),
        }
      ],
      questionList: [
        {
          title: '急速控蚊服务使用的药剂对人和宠物安全吗？',
          content: '虫虫拜拜控蚊服务使用的产品均为拜耳官方正品药剂，具备三证、HACCP认证并获得WHO推荐，产品本身在安全环保品质上处于行业领先水平。与此同时，我们的工程师都经过严格的理论实操培训，产品使用都将严格按照说明指示规范操作，现场给予你规范科学的引导，规避DIY的各种误区，真正免除您的安全顾虑。'
        },
      ],
      serveList: [
        {
          title: '服务项目',
          content: ['派对活动紧急控蚊服务']
        },
        {
          title: '服务内容',
          icon: 'iconserve-con',
          content: [
            {
              con: '检查：对室内外环境进行勘察分析',
              childCon: []
            },
            {
              con: '治理：全空间ULV空间喷雾处理、水体孑孓控制、滋生热点区滞留喷洒',
              childCon: []
            },
            {
              con: '根据现场检查处理出具专业服务报告',
              childCon: []
            },
          ]
        },
        {
          title: '服务频次',
          icon: 'iconserve-no',
          content: ['单次服务时常预计需约45分钟—1小时','*具体时长随房屋面积、虫害密度等情况略有浮动']
        },
        {
          title: '服务时长',
          icon: 'iconserve-time',
          content: ['快速灭杀区域内已有蚊虫，现场灭杀率达99.9%，保障整场活动蚊虫密度控制在极低水平']
        },
        {
          title: '服务建议',
          icon: 'iconserve-reslut',
          content: ['为了最佳的效果体验，服务时间建议不晚于活动开始前2个小时（且在食物进场前）']
        },
      ],
      sixEnsureList: [
        {
          title: '科学专业保障',
          img: require('../../static/images/iconkexue.svg'),
          content: '平台严选除虫工程师专业考核认证'
        },
        {
          title: '正品药剂保障',
          img: require('../../static/images/iconzhengpin.svg'),
          content: '全程使用国际品牌正品药剂 安全环保'
        },
        {
          title: '智能平台保障',
          img: require('../../static/images/iconzhineng.svg'),
          content: '专属个人账户，全新数字化平台，快速响应全方位售前售后支持'
        },
        {
          title: '价格透明保障',
          img: require('../../static/images/iconjiage.svg'),
          content: '收费规范透明，全程<br>无隐形、重复性收费'
        },
        {
          title: '专业保险保障',
          img: require('../../static/images/iconbaoxian.svg'),
          content: '100万平安雇主定制险保障<br>服务中客户的人身财产安全'
        },
        {
          title: '服务满意度保障',
          img: require('../../static/images/iconfuwu.svg'),
          content: '专业服务报告，服务全程可追溯定期回访确保满意度'
        }
      ]
    }
  },
  product_list: {
    unknownpest2: {
      name: "专业上门检测",
      id: "unknownpest2",
      product_name: 'profession',
      img: "icon-1.svg",
      text: "",
      index: 1
    },
    cockroach: {
      name: "蟑螂拜拜",
      id: "cockroach",
      product_name: 'zhanglang',
      img: "icon-2.svg",
      text: "",
      index: 2
    },
    rats: {
      name: "老鼠拜拜",
      id: "rats",
      product_name: 'laoshu',
      img: "icon-3.svg",
      text: "",
      index: 3
    },
    white_ant_check: {
      name: "白蚁灭治",
      product_name: 'baiyikancha',
      id: "white_ant_check",
      img: "icon-4.svg",
      text: "",
      index: 4
    },
    white_ant_precaution: {
      name: "白蚁预防",
      product_name: 'baiyiyufang',
      id: "white_ant_precaution",
      img: "icon-5.svg",
      text: "",
      index: 5
    },
    ants: {
      name: "蚂蚁拜拜",
      product_name: 'mayi',
      id: "ants",
      img: "icon-6.svg",
      text: "",
      index: 6
    },
    flea: {
      name: "跳蚤拜拜",
      product_name: 'tiaozao',
      id: "flea",
      img: "icon-7.svg",
      text: "",
      index: 7
    },
    cw_fly: {
      name: "厨卫飞虫",
      product_name: 'chuwei',
      id: "cw_fly",
      img: "icon-8.svg",
      text: "",
      index: 8
    },
    clothes_carpet_pest: {
      name: "织物害虫",
      product_name: 'zhiwu',
      id: "clothes_carpet_pest",
      img: "icon-9.svg",
      text: "",
      index: 9
    },
    mosquito: {
      name: "蚊虫拜拜",
      product_name: 'wenchong',
      id: "mosquito",
      img: "icon-10.svg",
      text: "",
      index: 10
    },
    silverfish: {
      name: "衣鱼拜拜",
      product_name: 'yiyu',
      id: "silverfish",
      img: "icon-11.svg",
      text: "",
      index: 11
    },
    bedbug: {
      name: "臭虫拜拜",
      product_name: 'chouchong',
      id: "bedbug",
      img: "icon-12.svg",
      text: "",
      index: 12
    },
    fly: {
      name: "苍蝇拜拜",
      product_name: 'cangying',
      id: "fly",
      img: "icon-fly.svg",
      text: "",
      index: 13
    }
  },
  blog_list: {
    '2': [
      {
        imgPc: require('../assets/images/pc/blog/cq01.jpg'),
        img: require('../assets/images/phone/blog/cq01.jpg'),
        title: '好烦啊，就没有办法把蟑螂一窝端了吗？',
        content: '如果你在家里看到了一只蟑螂，说明家里已经藏着成百上千只蟑螂。'
      },
      {
        imgPc: require('../assets/images/pc/blog/cq02.jpg'),
        img: require('../assets/images/phone/blog/cq02.jpg'),
        title: '蟑螂特别怂',
        content: '蟑螂胆小，渴望安全感。只有和同伴挤在一起时，它们心里才踏实。'
      },
      {
        imgPc: require('../assets/images/pc/blog/cq03.jpg'),
        img: require('../assets/images/phone/blog/cq03.jpg'),
        title: '家里蟑螂都不见了，方法就这么简单！',
        content: '你认为夏天就快过去了，蟑螂少了就不需要再灭蟑了，那就大错特了！'
      },
      {
        imgPc: require('../assets/images/pc/blog/cq04.jpg'),
        img: require('../assets/images/phone/blog/cq04.jpg'),
        title: '好烦啊，就没有办法把蟑螂一窝端了吗？',
        content: '如果你在家里看到了一只蟑螂，说明家里已经藏着成百上千只蟑螂。'
      },
      {
        imgPc: require('../assets/images/pc/blog/cq05.jpg'),
        img: require('../assets/images/phone/blog/cq05.jpg'),
        title: '好烦啊，就没有办法把蟑螂一窝端了吗？',
        content: '如果你在家里看到了一只蟑螂，说明家里已经藏着成百上千只蟑螂。'
      },
      {
        imgPc: require('../assets/images/pc/blog/cq06.jpg'),
        img: require('../assets/images/phone/blog/cq06.jpg'),
        title: '蟑螂特别怂',
        content: '蟑螂胆小，渴望安全感。只有和同伴挤在一起时，它们心里才踏实。'
      }
    ]
  },
  customer_evaluate: [
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 5,
      key: '检查仔细、操作专业',
      text: '师傅做事情非常细心',
    },
    {
      product_name: '专业上门检测',
      product_icon: 'iconbug',
      star: 5,
      key: '服务态度好、检查仔细',
      text: '很敬业、态度好',
    },
    {
      product_name: '专业上门检测',
      product_icon: 'iconbug',
      star: 5,
      key: '操作专业、穿着专业、上门准时',
      text: '服务态度好，专业',
    },
    {
      product_name: '蟑螂拜拜',
      product_icon: 'iconcockroach',
      star: 5,
      key: '讲解耐心、效果好、操作专业',
      text: '谢谢工程师的耐心和细致！',
    },
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 5,
      key: '效果好、服务态度好',
      text: '做的很到位，细心',
    },
    {
      product_name: '蟑螂拜拜',
      product_icon: 'iconcockroach',
      star: 5,
      key: '讲解耐心、上门准时、操作专业',
      text: '很专业，很满意，质保期内还支持后续服务，下次还会找你们家！',
    },
    {
      product_name: '蟑螂拜拜',
      product_icon: 'iconcockroach',
      star: 5,
      key: '检查仔细、讲解耐心、服务态度好',
      text: '挺好的，效果好的话接下来发朋友圈推荐。',
    },
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 5,
      key: '穿着专业、服务态度好、效果好',
      text: '服务态度很好，工作到位',
    },
    {
      product_name: '蟑螂拜拜',
      product_icon: 'iconcockroach',
      star: 5,
      key: '服务态度好、检查仔细',
      text: '服务的非常好，很细致周到，我们以后还会利用。',
    },
    {
      product_name: '专业上门检测',
      product_icon: 'iconbug',
      star: 5,
      key: '检查仔细、服务态度好',
      text: '检查的非常到位、',
    },
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 5,
      key: '操作专业、上门准时、讲解耐心',
      text: '师傅很专业，认真负责，非常好',
    },
    {
      product_name: '专业上门检测',
      product_icon: 'iconbug',
      star: 5,
      key: '穿着专业、讲解耐心、操作专业',
      text: '两位技术人员非常专业仔细，对服务解释的很清楚明白。',
    },
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 4,
      key: '上门准时、服务态度好、检查仔细',
      text: '师傅都做得好好！效果还不知道！过段时间再说！',
    },
    {
      product_name: '跳蚤拜拜',
      product_icon: 'iconflea4',
      star: 5,
      key: '检查仔细、效果好',
      text: '检测专业，服务态度很好',
    },
    {
      product_name: '蟑螂拜拜',
      product_icon: 'iconcockroach',
      star: 5,
      key: '检查仔细、服务态度好',
      text: '还不错吧挺好',
    },
    {
      product_name: '跳蚤拜拜',
      product_icon: 'iconflea4',
      star: 5,
      key: '效果好、服务态度好、操作专业',
      text: '认真负责，灭蚤专业，效果明显',
    },
    {
      product_name: '蟑螂拜拜',
      product_icon: 'iconcockroach',
      star: 5,
      key: '检查仔细、服务态度好',
      text: '师傅专业细心、把角角落落都检查的一丝不苟、真是太棒了',
    },
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 5,
      key: '操作专业、效果好',
      text: '非常厉害的技师！！！！当天晚上就抓到一只老鼠了！',
    },
    {
      product_name: '跳蚤拜拜',
      product_icon: 'iconflea4',
      star: 5,
      key: '穿着专业、讲解耐心、效果好',
      text: '工程师专业又非常负责',
    },
    {
      product_name: '跳蚤拜拜',
      product_icon: 'iconflea4',
      star: 5,
      key: '服务态度好、效果好',
      text: '感谢你的服务，认真负责。',
    },
    {
      product_name: '蚂蚁拜拜',
      product_icon: 'iconbug',
      star: 5,
      key: '操作专业、检查仔细',
      text: '找出了我们实验室小红蚂蚁其实是叫肿腿蜂的一种昆虫',
    },
    {
      product_name: '专业上门检测',
      product_icon: 'iconbug',
      star: 5,
      key: '讲解耐心、效果好、操作专业',
      text: '非常感谢工程师耐心专业的建议指导',
    },
    {
      product_name: '专业上门检测',
      product_icon: 'iconbug',
      star: 5,
      key: '上门准时、检查仔细、效果好',
      text: '小哥哥特别认真仔细，很负责也很守时。绝对要点赞！👍',
    },
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 5,
      key: '检查仔细、操作专业',
      text: '服务专业，认真负责，继续加油',
    },
    {
      product_name: '专业上门检测',
      product_icon: 'iconbug',
      star: 4,
      key: '操作专业',
      text: '技术水平专业',
    },
    {
      product_name: '跳蚤拜拜',
      product_icon: 'iconflea4',
      star: 5,
      key: '上门准时、讲解耐心、操作专业',
      text: '准時，很認真，且會說明情況，並提供建議',
    },
    {
      product_name: '跳蚤拜拜',
      product_icon: 'iconflea4',
      star: 5,
      key: '服务态度好、讲解耐心、效果好',
      text: '工程师服务认真，仔细，态度和蔼，不怕辛苦，服务三刺青，每次都是认真负责，我们非常满意。',
    },
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 5,
      key: '检查仔细、效果好',
      text: '仔细认真，业务熟练',
    },
    {
      product_name: '包年服务',
      product_icon: 'iconcontract',
      star: 5,
      key: '上门准时、检查仔细、操作专业',
      text: '有专业水准，准时上门，检查仔细认真。',
    },
    {
      product_name: '老鼠拜拜',
      product_icon: 'iconmouse',
      star: 5,
      key: '操作专业、讲解耐心',
      text: '工程师很专业，服务非常好！',
    },
    {
      product_name: '蟑螂拜拜',
      product_icon: 'iconcockroach',
      star: 5,
      key: '穿着专业、服务态度好、效果好',
      text: '非常感谢，真心谢谢周师傅，希望不要再有小强了',
    },
    {
      product_name: '跳蚤拜拜',
      product_icon: 'iconflea4',
      star: 5,
      key: '服务态度好、上门准时、操作专业',
      text: '工程师服务态度非常棒，又很专业。2次上门灭虫后，果然已无跳蚤，效果特别显著。',
    },
    {
      product_name: '蟑螂拜拜',
      product_icon: 'iconcockroach',
      star: 5,
      key: '检查仔细、讲解耐心、效果好',
      text: '工程师非常仔细！效果很好',
    }
  ],
  contact_us: {
    '1': [
      {
        title: '专业科学',
        detail: '国际技术培训，100%持证 上岗，量身定制解决方案',
        img: 'contact_us_1.png'
      },
      {
        title: '安全环保',
        detail: '拜耳进口药剂，环保无异味，保证家人和宠物健康',
        img: 'contact_us_2.png'
      },
    ],
    '2': [
      {
        title: '无忧保障',
        detail: '专业全面的售后支持和保障，免去后顾之忧',
        img: 'contact_us_3.png'
      },
      {
        title: '快速上门',
        detail: '在线下单，快速预约专家，上门服务',
        // detail: '拜耳进口药剂，环保无异味，保证家人和宠物健康',
        img: 'contact_us_4.png'
      },
    ],
    '3': [
      {
        title: '全程托付',
        detail: '无需再亲自动手，一步到位，省心放心',
        img: 'contact_us_5.png'
      },
      {
        title: '德国品质',
        detail: '严格质量把控，全程系统记录',
        img: 'contact_us_6.png'
      }
    ]
  },
  //百科
  pest_wiki_list: [
    {
      product_id: 'cockroach',
      product_name: '蟑螂',
      detail: '最常见的家庭卫生害虫',
      color_type: 0,
      img: '1@1x.png',
      code: 394,
      title: '蟑螂_蟑螂怎么消灭_除蟑螂最有效的方法-拜耳虫虫拜拜官网',
      keywords: '蟑螂,小强,德国小蠊,大蠊,蟑螂的危害',
      description: '温暖潮湿、食物丰富和多缝隙，是蟑螂孳生的基本条件。我们的生活工作空间，不管是厨房还是卫生间，甚至是散落了食物碎屑的沙发都有可能成为蟑螂的入侵点。',
    },
    {
      product_id: 'white_ant_check',
      product_name: '白蚁',
      detail: '房屋建筑的无声破坏者',
      color_type: 0,
      img: '3@1x.png',
      code: 379,
      title: '白蚁_白蚁怎么消灭_白蚁防治方法-拜耳虫虫拜拜官网',
      keywords: '白蚁,灭白蚁服务公司,飞蚂蚁,台湾乳白蚁,散白蚁,白蚁的危害',
      description: '作为最古老的社会性昆虫之一，白蚁常被视为破坏力最大的害虫。白蚁群体中有明确“社会分工”，往往种族庞大，尤其是台湾乳白蚁，常有多个隐匿藏身处，处理难度较大。',
    },
    {
      product_id: 'rats',
      product_name: '老鼠',
      detail: '不容小觑的啮齿类动物',
      color_type: 0,
      img: '2@1x.png',
      code: 389,
      title: '老鼠_老鼠怎么消灭_抓老鼠最有效方法-拜耳虫虫拜拜官网',
      keywords: '老鼠,老鼠怎么消灭,耗子,小家鼠,褐家鼠,黄胸鼠',
      description: '老鼠是现存最原始的哺乳动物之一，生命力旺盛、数量繁多且迅速。凭借超强的适应能力和智商，老鼠几乎适应了各地的环境，这也给人类带来了源源不断的困扰和危害。',
    },
    {
      product_id: 'ants',
      product_name: '蚂蚁',
      detail: '团结一致爱吃甜食的偷运工',
      color_type: 0,
      img: '4@1x.png',
      code: 390,
      title: '蚂蚁_蚂蚁怎么消灭_虫害百科-拜耳虫虫拜拜官网',
      keywords: '蚂蚁,蚂蚁防治方法,小黄家蚁,红火蚁,弓背蚁,蚂蚁的危害',
      description: '蚂蚁是常见社会性昆虫，依据形态、行为和社会分工可分为：雌蚁、雄蚁、工蚁和兵蚁。各品级各司其职。蚂蚁如果入侵室内，也会对人们的工作、生活带来危害和滋扰。',
    },
    {
      product_id: 'flea',
      product_name: '跳蚤',
      detail: '擅长跳跃吸食人血的寄生兽',
      color_type: 0,
      img: '5@1x.png',
      code: 391,
      title: '跳蚤_跳蚤怎么消灭_跳蚤防治方法-拜耳虫虫拜拜官网',
      keywords: '跳蚤怎么消灭,跳蚤,猫蚤,狗蚤,跳蚤的危害',
      description: '跳蚤是一种小型、无翅、善跳跃的寄生性昆虫，通常寄生在哺乳类动物和鸟类身上，有锐利的刺吸式口器。跳蚤叮咬会产生瘙痒、过敏反应，还可能传播疾病。',
    },
    {
      product_id: 'fly',
      product_name: '苍蝇',
      detail: '边吃边吐边拉的病菌传播者',
      color_type: 0,
      img: '6@1x.png',
      code: 381,
      title: '苍蝇_苍蝇怎么消灭_驱除苍蝇-拜耳虫虫拜拜官网',
      keywords: '苍蝇,卫生害虫,苍蝇的危害',
      description: '苍蝇多以腐败有机物为食，具有舐吮式口器，会污染食物，传播疾病，是一种常见的卫生害虫，喜欢在人或畜的粪尿、痰、呕吐物以及尸体等处爬行觅食，容易附着病原体。',
    },
    {
      product_id: 'mosquito',
      product_name: '蚊子',
      detail: '全世界致死率最高的动物',
      color_type: 0,
      img: '7@1x.png',
      code: 392,
      title: '蚊子_灭蚊虫最有效的方法_蚊子怎么消灭-拜耳虫虫拜拜官网',
      keywords: '蚊子,伊蚊,花脚蚊,蚊子的危害',
      description: '蚊子是一种具有刺吸式口器的细小昆虫。一般雄蚊以植物汁液为食，唯雌蚊吸取血液。蚊子的唾液会使宿主出现皮疹等症状，且是许多种疾病的传播媒介。',
    },
    {
      product_id: 'bedbug',
      product_name: '臭虫',
      detail: '会分泌臭液的吸血寄生虫',
      color_type: 0,
      img: '8@1x.png',
      code: 383,
      title: '臭虫_臭虫怎么消灭_杀臭虫最有效方法-拜耳虫虫拜拜官网',
      keywords: '臭虫,床虱,臭虫的危害',
      description: '成年臭虫呈褐红色，扁平带椭圆形，少数臭虫有翅膀且会飞。臭虫以人类血液为食，它的首选栖息地是床板，尤其是病床或其他公共场所的床。臭虫抗药性强，根除十分困难。',
    },
    {
      product_id: 'mite',
      product_name: '寄螨',
      detail: '会反复吸血，叮咬引发疼痛',
      color_type: 0,
      img: '9@1x.png',
      code: 388,
      title: '寄螨_怎样除螨虫_螨虫防治方法-拜耳虫虫拜拜官网',
      keywords: '寄螨,蜱虫,革螨,寄生性害虫,蜱虫的危害',
      description: '寄螨总目包含所有蜱螨类生物，大多数是寄生生物，其中革螨、蜱对人类生活危害较大，会对人发起攻击，通过叮咬、吸血等方式致使人过敏、皮炎甚至严重疾病。',
    },
    {
      product_id: 'silverfish',
      product_name: '衣鱼',
      detail: '喜欢潮湿爱吃甜食的书虫',
      color_type: 0,
      img: 'feiyu@1x.jpg',
      code: 393,
      title: '衣鱼_消灭衣鱼虫的经验_如何杀死衣鱼-拜耳虫虫拜拜官网',
      keywords: '衣鱼,书虫,衣鱼防治建议,消灭衣鱼虫的经验',
      description: '衣鱼俗称书虫，是一种无翅昆虫，尾部有三根长毛（缨尾），常躲藏在黑暗处，滋生地通常比较潮湿，会啃食书籍、衣物、墙纸装潢等。',
    },
    {
      product_id: 'cw_fly',
      product_name: '厨卫飞虫',
      detail: '喜欢潮湿和腐败有机质',
      color_type: 1,
      img: '10@1x.png',
      code: 384,
      title: '厨卫飞虫_厨卫飞虫怎么消灭_厨卫飞虫防治方法-拜耳虫虫拜拜官网',
      keywords: '厨卫飞虫怎么处理,厨卫飞虫,蛾蚋,果蝇,蚤蝇,蕈蚊',
      description: '常见的厨卫飞虫有蛾蚋、果蝇、蚤蝇、蕈蚊等。这些飞虫基本不咬人，但由于其滋生地通常为藏污纳垢之处，容易接触和携带环境中的细菌，给人带来滋扰危害。',
    },
    {
      product_id: 'clothes_carpet_pest',
      product_name: '织物害虫',
      detail: '喜食角蛋白，破坏皮革植物',
      color_type: 1,
      img: '11@1x.png',
      code: 395,
      title: '织物害虫_织物害虫怎么消灭_织物害虫防治方法-拜耳虫虫拜拜官网',
      keywords: '家庭虫害防治,织物害虫,衣蛾,皮蠹',
      description: '织物/地毯害虫以天然蛋白质（角蛋白）为食，任何动物来源的织物材料都可能成为它们破坏的对象，包括羊毛、棉花、丝绸、皮革和羽毛等，有些也会危害粮食谷物。',
    },
    {
      product_id: 'woods_pest',
      product_name: '蛀木害虫',
      detail: '以木材为食或在里筑巢产卵',
      color_type: 1,
      img: '12@1x.png',
      code: 396,
      title: '蛀木害虫_蛀木害虫怎么消灭_蛀木害虫防治方法-拜耳虫虫拜拜官网',
      keywords: '家庭驱虫公司,蛀木害虫,粉蠹,窃蠹,天牛',
      description: '蛀木害虫会对房屋木质结构和木家具等造成破坏，通常是被携带进入或从外部入侵室内，大多有趋光性，随着绿化建设不断提升，入侵室内的可能性也随之增高。',
    },
    {
      product_id: 'bees',
      product_name: '叮蛰害虫',
      detail: '会蜇人引起疼痛瘙痒的刺客',
      color_type: 1,
      img: '13@1x.png',
      code: 385,
      title: '叮蛰害虫_叮蛰害虫怎么消灭_叮蛰害虫防治方法-拜耳虫虫拜拜官网',
      keywords: '家庭虫害防治,叮蛰害虫,寄生蜂,蜜蜂,黄蜂',
      description: '叮蛰害虫多为社会性昆虫，由蜂王、雄蜂、工蜂等组成。在感到自身或蜂群受到威胁时，会以叮蛰进行防卫。叮蛰害虫中，只有雌性才会叮蛰，有些叮蛰害虫毒性十分强。',
    },
    {
      product_id: 'wet_pests',
      product_name: '潮湿害虫',
      detail: '喜欢潮湿，通常集体出现',
      color_type: 1,
      img: '14@1x.png',
      code: 382,
      title: '潮湿害虫_潮湿害虫怎么消灭_潮湿害虫防治方法-拜耳虫虫拜拜官网',
      keywords: '潮湿害虫,潮湿害虫怎么处理,书虱,米扁虫,薪甲,伪瓢虫',
      description: '很多家庭楼层较低或家居没做好防潮处理，很容易出现墙体发霉、微菌滋生、虫害繁殖的情况，在这些区域常出现的害虫被统称为潮湿害虫。',
    },
    {
      product_id: 'storage_pests',
      product_name: '仓储害虫',
      detail: '会对粮食、食物造成污染',
      color_type: 1,
      img: '15@1x.png',
      code: 380,
      title: '仓储害虫_仓储害虫怎么消灭_仓储害虫防治方法-拜耳虫虫拜拜官网',
      keywords: '仓储害虫,锯谷盗,米象,烟草甲,印度谷螟,仓储害虫防治方法',
      description: '仓储害虫常见于谷物、麦子、脱水的水果和种子中，无论是家庭还是商用场所如食品工厂、仓库、餐厅等都可见到它们的身影，会对粮食储物造成污染和危害',
    },
    {
      product_id: 'multipod_pests',
      product_name: '多足害虫',
      detail: '外形可怕喜欢阴湿的爬虫',
      color_type: 1,
      img: '16@1x.png',
      code: 386,
      title: '多足害虫_多足害虫怎么消灭_多足害虫防治方法-拜耳虫虫拜拜官网',
      keywords: '家庭虫害防治,多足害虫,千足虫,蜈蚣,蚰蜒,马陆',
      description: '多足害虫多以腐殖质或小昆虫为食，常见于室外草地、土壤中，喜欢阴暗潮湿的环境，但有时也会因湿度、食物、植物携带等原因进入室内，造成危害。',
    },
    {
      product_id: 'garden_pests',
      product_name: '花园害虫',
      detail: '常见于花园绿化，室内偶见',
      color_type: 1,
      img: '17@1x.png',
      code: 387,
      title: '花园害虫_花园害虫怎么消灭_花园害虫防治方法-拜耳虫虫拜拜官网',
      keywords: '驱害虫服务公司,花园害虫,蜘蛛,蛞蝓,蝽,隐翅虫',
      description: '草坪、花园、绿化当中是各类甲虫、爬虫、飞虫等害虫聚集的热点区域，我们将其统称为花园害虫。偶尔它们会因觅食或在室内寻到合适的栖息地，或被灯光吸引入侵室内。',
    },
  ],
  faq_list: [
    {
      title: '常见问题',
      detail: [
        {
          question: '为什么我需要使用专业有害生物防治服务？好像我自己也可以解决？',
          answer: '害虫会对人们的生活、生产带来滋扰和危害，而且很多害虫由于昼伏夜出，活动隐蔽常常会被人们所忽视。虫虫拜拜的工程师均经过严格的培训，可以根据害虫生活习性对症下药，并给出专业的防护建议。相比于自己DIY，专业的有害生物防治服务可以给您节省大量的时间精力，您无需再和可憎的害虫正面交锋，也不用担心药剂是否安全，家人的健康和处理的效果都能得到保障。',
          show: false,
          code: 207,
        },
        {
          question: '害虫对我的家人有哪些危害？',
          answer: '害虫的危害通常表现为：1）入侵人们的生活工作空间，造成滋扰；2）通过叮咬、吸血、污染食物等途径传播疾病，危害健康；3）污染和破坏食物、家具、建筑等，带来财产损害。\n' +
          '一些数据可以表明：全球病媒生物传播的疾病占全部传染病的17%以上，每年导致70多万人死亡；许多害虫还是容易被忽视的过敏原，譬如每年全球约有3000万人因蟑螂、老鼠等害虫而诱发哮喘；每年全球有40余万人因蚊虫患疟疾死亡，其中大部分为五岁以下儿童。',
          show: false,
          code: 209,
        },
        {
          question: '长三角地区最常见的害虫有哪些？',
          answer: '长江三角洲是典型的亚热带季风气候，温暖湿润，适合害虫生长繁殖，虫害种类繁多。侵入住宅的常见虫害有老鼠，蟑螂、白蚁、跳蚤、蚊子、苍蝇、蚂蚁、臭虫、伪瓢虫、衣鱼、黑皮蠹、小圆皮蠹、衣蛾、跳虫、蚤蝇、马陆等。别墅和低层住户遇到害虫的几率更大。\n' +
          '遇到虫害问题无法确认？被叮被咬？马上来“这是什么虫”识别害虫真身！',
          show: false,
          code: 210,
        },
      ]
    },
    {
      title: '有关治理',
      detail: [
        {
          question: '服务完多久可以看到效果？效果可以维持多长时间？',
          answer: '一般服务结束当天就能看到服务效果，如看到虫子的尸体、活动的虫子数量大幅减少。从开始见效到除尽，中间时间根据不同害虫种类和现场环境会有所不同。以蟑螂为例，其危害区域分散且活动能力强，为了灭巢，我们会利用其群居属性，采用慢性致死的方式使药效在其群体内传播，通常会有5-10天左右的见效期。\n' +
          '治理的效果和持效期需要结合客户的配合。虫虫拜拜工程师会通过服务中的沟通以及后续服务报告给到客户有针对性的防护整改建议。双方互相配合下，大部分虫害防治都能维持非常长的一段时间。同时虫虫拜拜针对不同虫害，会给到家庭客户一定质保期，如蟑螂、老鼠为3个月，白蚁可以长达3年。质保期内如因服务导致效果不佳，我们会提供免费的额外服务。',
          show: false,
          code: 208,
        },
        {
          question: '虫害处理服务对我的家人和宠物安全么？',
          answer: '虫虫拜拜服务使用的产品，90%以上来自拜耳（其余来自国际知名厂商）所有产品均有三证资质。相比于市面上大部分除虫药剂，在安全环保品质上处于行业领先水平。并且我们的工程师都需经过严格的理论实操培训，所有的药剂使用都会严格按照说明指示规范操作，所以即使您家有小孩、宠物，也不用担心。部分药剂在使用时会需要回避一下，如药液的喷洒，避免因为药液滑倒或污染药液（或吸入鼻中）。待1-2小时药液干了以后便可正常进出，不影响日常生活。',
          show: false,
          code: 211,
        },
        {
          question: '虫虫拜拜提供哪些的害虫治理方案？',
          answer: '虫虫拜拜可为大部分的家庭害虫提供专业解决方案，常见害虫如蟑螂、老鼠、白蚁、跳蚤等，客户可以通过官网、微信、天猫等途径自行下单。一些不太常见或无法确定的虫害，用户可以选择我们的专业检测服务入口进行预约，或与我们的客服联系，我们会给您提供合适的解决方案。',
          show: false,
          code: 212,
        },
      ]
    },
    {
      title: '周期性服务',
      detail: [
        {
          question: '我家的虫子种类比较多，想全都处理，有什么省心的统包服务吗？',
          answer: '像别墅、老洋房、一楼大平层用户等环境比较综合，遇到的害虫种类会比较多。虫虫拜拜也为这类用户提供包年类型的贴心管家式服务。服务期内，工程师会针对您的处所提供全面处理和预防、定期虫害监测，将问题扼杀在出现之前；工程师还会根据实际情况，结合虫害预防分享一些健康生活的小知识；如果您对虫害相关问题有疑问，或家中发现紧急异常问题，还可优先咨询、呼叫虫虫拜拜工程师上门免费服务。如您需要了解更多关于包年服务的信息，可在线咨询客服，或联系我们的客服热线：400-188-8282。',
          show: false,
          code: 213,
        },
        {
          question: '为什么跳蚤，老鼠，臭虫等虫害问题需要多次上门处理？',
          answer: '有些虫害问题比较复杂，处理难度相对也比较高。譬如老鼠，不仅是捕捉，还要检查房屋的漏洞；臭虫则比较顽固，有很强的抗药性；跳蚤有很强的流动性，且幼虫可以在茧内长期静伏。为了保证最佳的治理效果，这类害虫会需要多次上门，以确定和扫除潜在的风险。所有的上门均包含在一次性收费当中，您无需额外支付费用。',
          show: false,
          code: 214,
        },
        {
          question: '我没有看到有害虫，也有必要定期进行虫害防治吗？',
          answer: '最有效的虫害防治还是在于防，防患于未然。很多害虫昼伏夜出、善于躲藏，平时并不容易被发现。等到发现再去处理时，可能已经带来了较大的损失。以白蚁为例，大多数情况下，在新房建造和装修期间便可以做预防处理，以保证房屋和家具长久的安全完好。类似于健康体检，对害虫的定期检查和预防，也是非常有必要的。',
          show: false,
          code: 215,
        },
      ]
    },
  ],
  about_list: [
    {
      name: "专业上门检测",
      id: "unknownpest2",
      product_name: 'profession',
      img: "icon-12.svg",
      text: "立即预约环境专家给房屋做个体检",
      index: 1,
      title: '专业上门虫害检测_家庭除虫服务-拜耳虫虫拜拜官网',
      keywords: '专业虫害检测,除虫服务,家庭除虫服务,虫害防治专家,上门除虫,虫子识别',
      description: '拜耳虫虫拜拜自有工程师将通过专业、全面、有针对性的勘察，帮您准确判断家中的虫害问题。',
      noscritp: '为何需要专业检测 很多情况下，房主并不知道家中是否有虫害问题。许多常见害虫，尤其是它们的幼虫、虫卵，个头小、难辩别，容易被忽视 即使是像蟑螂、老鼠人们以为熟知的害虫，大众的认知也存在许多误区。很多人尝试自己解决，但一般都只处理到可见的感染 而墙面下和裂缝深处等不为人所注意的地方，才是这些害虫的“栖息地”，这是家庭解决方案无法触及的区域。 害虫的入侵会对人们的日常生活造成严重影响，甚至会危害人和宠物的健康：轻则皮肤发痒，重则引起严重的过敏和细菌病毒感染！ 有些害虫还会对家具及房屋造成破坏，带来潜在的安全隐患 专业上门检测 服务热线： 400-188-8282 快速预约 哪些情况您需要担心虫害问题？ 小孩哮喘、皮肤红肿发痒、身体有异物感、过敏性鼻炎等慢性疾病，其罪魁祸首很可能是因为家中遭到了害虫入侵 家中出现过渗水情况，或者曾出现过地板浸水及墙面起过“霉菌” 周围邻居家有发现虫害，有可能带来潜在威胁 家中出现不明黑点、可疑迹象、奇怪声响或异常气味 家具上出现掉漆、孔洞、破损、松动、脱落等情况 直接发现小虫子的活体、尸体或活动迹象 专业服务 服务工序 工程师上门 工程师将先与您沟通当前情况，对现场情况进行分析预估 现场勘察 通过专业、全面、有针对性的勘察，准确判断您家的虫害问题 情况汇报 工程师将与您沟通阐释家庭中已有或潜在的害虫风险，并与您沟通是否需要后续的预防 后续处理 若客户需要并确认后续服务方案，工程师将展开专业处理 专业报告 每一次的检测和服务，我们都会通过智能分析管理平台生成专业报告 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "蟑螂拜拜",
      id: "cockroach",
      product_name: 'zhanglang',
      img: "icon-1.svg",
      text: "56个排查点，3月质保",
      index: 2,
      title: '灭除蟑螂_杀蟑螂_专业上门消灭蟑螂服务-拜耳虫虫拜拜官网',
      keywords: '除蟑螂,上门除蟑螂,上门除虫,蟑螂胶饵',
      description: '拜耳虫虫拜拜可以快速灭除蟑螂。自有工程师团队将根据现场环境，使用拜耳官方正品药剂对症下药，强效吸引，隔夜见效，效果持久。',
      noscritp: '蟑螂的危害 蟑螂是食腐动物，几乎所有东西都可能成为它的食物。而且它边吃边拉，会对食物和生活环境造成污染 小强携带约40种病菌，可能引发哮喘、肺炎、痢疾、结核病、白喉、猩红热等疾病（数据来源于中国疾控中心） 一只雌性德国小蠊一年可繁衍10,000只后代。加上它是群居性昆虫，看到一只往往意味着有更多躲在暗处 蟑螂喜欢昼伏夜出、钻缝藏洞，常通过快递盒、外卖包装等潜入家中。电话机、游戏机、冰箱缝都可能是它的栖身处 蟑螂有最原始的咀嚼式口器，会咬坏电线线路等物品，造成事故隐患 蟑螂拜拜 快速 长效 安全 无痕 无忧 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 诱饵站 根据蟑螂生物习性设计，独特纹路引导小强上钩，超强“*屏蔽的关键字*库”使效果更持久显著 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 现场勘查 厨房、卫生间等56个排查点，让蟑螂无处遁形 环境分析 工程师结合专业生物知识对您家中情况进行剖析 施药处理 蟑螂也分好多种，对症下药才是关键 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 长效保障 我们为您提供90天质保，期间若蟑螂问题未改善，我们将升级工程师，无偿返工 效果 强效吸引 独特配方技术，蟑螂即使拒食葡萄糖也难抵我们专业药剂的诱惑 隔夜见效 新ContaX触杀技术、多米诺效应双效合一；服务后第二天即可见效，1-2周蟑螂无影无踪 隐形屏障 工程师施药点安全隐蔽，为您撑起隐形屏障，一次服务，长效保障 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "老鼠拜拜",
      id: "rats",
      product_name: 'laoshu',
      img: "icon-2.svg",
      text: "全面处理，杜绝隐患",
      index: 3,
      title: '灭除老鼠_专业上门灭鼠公司-拜耳虫虫拜拜官网',
      keywords: '上门除老鼠,捉老鼠,除虫公司',
      description: '拜耳自有工程师团队，帮您识别隐蔽鼠迹，通过布控关键点快速捕捉老鼠，并找出建筑环境风险点，使用专业材料封堵，消除后续隐患。',
      noscritp: '老鼠的危害 现实中的老鼠黑不溜秋尖嘴缩腮，可不是荧幕上的可爱形象，如果潜入您家，可能带来巨大的危害 老鼠是啮齿类动物，容易对线路、通讯、家具甚至房屋结构造成破坏，引发事故 老鼠常出没于下水道、垃圾堆，能传播35种以上疾病，如流行性出血热、班疹伤寒、狂犬病、鼠疫等 老鼠繁殖迅速，一对褐家鼠一年可以繁衍2，000只后代。千防万防，老鼠难防 老鼠可以钻过6mm的孔洞，还有惊人的听觉、嗅觉、触觉，十分谨慎聪明，智商比肩5岁小孩 老鼠拜拜 精准 安全 全面 环保 智能 服务热线： 400-188-8282 快速预约 专业工具 Bell trap gel 美国贝尔实验室特效引诱剂，根据老鼠喜好设计的特殊风味，效果卓著，安全环保 强力粘鼠板 中日合资企业出品，全国爱卫会推荐产品，超强黏胶，让老鼠束手就擒 拜耳专业药剂 独特剂型，安全高效，有效解决老鼠拒食困扰 红外线捕鼠器 自动感应，连续捕鼠，再聪明狡猾的老鼠也难逃法网 封堵材料 多种专业封堵材料，兼顾美观的同时从根本上阻绝老鼠的来路 专业服务 服务工序 追踪鼠迹 识别排泄物、脚印、咬痕和毛发擦痕，描绘活动路径 环境分析 全方位环境分析，找出建筑和环境的所有风险点 全面处理 多次上门诱捕灭防，不给老鼠留一丝机会 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 持续保障 服务完成后，我们的工程师和客服会不定期回访，并提供90天的免费质保 效果 快速捕获 工程师准确判断室内是否仍有老鼠藏匿，并设置陷阱快速捕获躲藏的老鼠 高效灭杀 只要取食，甚至是沾染了我们的拜耳专业药剂，老鼠就会中招 杜绝隐患 科学细致的孔洞封堵工作，将潜在隐患因子有效隔绝 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "白蚁灭治",
      id: "white_ant_check",
      product_name: 'baiyikancha',
      img: "icon-3.svg",
      text: "护卫房屋装潢",
      index: 4,
      title: '白蚁灭治_白蚁防治_专业上门除灭白蚁公司-拜耳虫虫拜拜官网',
      keywords: '白蚁灭治,白蚁勘察,白蚁危害,白蚁公司,白蚁灭治服务公司',
      description: '白蚁会严重危害房屋建筑且入侵不易察觉。拜耳虫虫拜拜提供专业的白蚁勘查和灭治服务，为您竖起保护建筑的“金钟罩”。',
      noscritp: '白蚁的危害 白蚁和蚂蚁完全不同，和蟑螂反而是近亲，是一种严重危害房屋建筑的害虫 它能蛀食书籍、家具、地板、房屋、桥梁堤坝等，破坏力极大 白蚁入侵途径多样，3-6月是它的婚飞季，30多层的高层都有可能被入侵 白蚁蚁后繁殖能力超强，每天能产生上万个卵，有些品种的蚁后甚至可以孤雌繁殖 白蚁侵害不易发觉，被称为“无声破坏者”，被发现时往往已经造成巨大损失 白蚁灭治 精准 预防 安全 长效 灭巢 服务热线： 400-188-8282 快速预约 江浙沪地区最易遭受三种白蚁入侵 台湾乳白蚁 世界上危害最大的白蚁，破坏力最强，轻易入侵高层建筑 黑胸散白蚁 一个蚁群有数千只，破坏主要集中在建筑低层区域 黄胸散白蚁 婚飞季节最早，蚁道隐蔽不易发现 什么情况下您亟需白蚁灭治？ 1 地板表面起泡、掉漆，地板松动翘起 2 地板表面起泡、掉漆，地板松动翘起 3 地板表面起泡、掉漆，地板松动翘起 4 地板表面起泡、掉漆，地板松动翘起 然而大多数情况下白蚁入侵的迹象隐蔽而不易察觉，待意识到问题时往往白蚁已在家中筑巢，数量和危害已经到达比较严重的程度。因此，若您家中符合以下任意一种情况，您也可以请专业的工程师上门勘查，未雨绸缪。 家中装修配置了较多的木制家具 之前家中出现过渗水情况，尤其是木制结构区域 房屋外围绿化率高，春夏季常有白蚁纷飞 发现周围邻居家中有白蚁问题 专业工具 拜耳专业药剂 WHO推荐的非趋避性产品，安全低毒，药效持久 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 建筑工具和材料 进口五金器械和密封修补材料，确保破坏最小、复原最佳 智能分析管理平台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 效果 地上型蚁站安装方便，大大减少人工成本，无需破坏任何室内装潢 地下型蚁站埋设在地下，将需要保护的区域包围起来，可对该区域的白蚁进行有效的检测和拦截 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "白蚁预防",
      id: "white_ant_precaution",
      product_name: 'baiyiyufang',
      img: "icon-4.svg",
      text: "给房屋上保险",
      index: 5,
      title: '白蚁预防_白蚁防治-拜耳虫虫拜拜官网',
      keywords: '白蚁预防,上门白蚁预防公司,装修预防白蚁,除白蚁公司,除虫公司',
      description: '白蚁危害严重，但在问题发生前，拜耳虫虫拜拜可以对房屋进行全面的预防处理，有效阻绝白蚁入侵，保障建筑和家具安全。',
      noscritp: '白蚁-无声破坏者 白蚁善于潜伏，是名副其实的“地下工作者”，待到发现时往往已经造成巨大损失 白蚁喜欢钻墙打洞，受到侵害的建筑或装潢、家具外表上可能难寻蛛丝马迹，而内里可能已经千疮百孔 白蚁蛀食木制家具、房梁、吊顶、地板、书籍等，破坏力强，涉入面广 白蚁蚁后繁殖能力超强，每天能产生上万个卵，有些品种的蚁后甚至可以无性繁殖 白蚁预防 服务热线： 400-188-8282 快速预约 为何频频发生白蚁危害？ 环境因素 随着城市环境不断改善，房屋四周绿化不断扩大，白蚁生存条件越加优越，白蚁群体通过分飞或通过土层蔓延扩散侵袭建筑物的机会增加 携带因素 白蚁易伴随货物、运输工具、包装和装修材料等，被人为携带传播到新地，在适宜的室内环境中定居下来 食料因素 旧城改造或新征土地建房，房屋地基本身就有白蚁巢或残留下的木料中有白蚁，施工时没清除干净，为新建房屋留下了隐患 灯光因素 白蚁有趋光性，尤其是分飞季节，会被室内光源吸引并在建筑物中择地筑巢 给您的房屋上个保险 白蚁危害严重，但在问题发生前，我们也可以对房屋进行全面的预防处理，为其罩上“长效防护网”。 装修前 装修后 服务工序 工程师上门 了解施工装修计划 现场测量 制定预防处理方案 客户方案确认 展开预防处理 工程师上门 现场诊断 建筑结构、装潢测定 制定防治计划 客户方案确认 展开防治服务 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 效果 防御“金钟罩” 有效阻绝白蚁入侵，其他织物、地板害虫等风险也大大降低，有效保障建筑和家具安全 效果持久 一次处理，持久防护。虫虫拜拜为白蚁预防处理提供3年质保期，让您没有后顾之忧 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "蚂蚁拜拜",
      id: "ants",
      product_name: 'mayi',
      img: "icon-5.svg",
      text: "连锁灭杀，立竿见影",
      index: 6,
      title: '灭除蚂蚁_蚂蚁防治_专业上门除蚂蚁服务-拜耳虫虫拜拜官网',
      keywords: '除蚂蚁,除白蚁公司,上门除虫,蚂蚁防治方法',
      description: '虫虫拜拜使用拜耳官方正品药剂，强效吸引蚂蚁；专业工程师展开勘查，快速找出屋内蚂蚁活动点和滋生源，连锁灭杀，立竿见影。',
      noscritp: '蚂蚁的危害 一些蚂蚁如小黄家蚁、红火蚁等会叮咬人，特别是小孩，引起皮肤发炎红肿，甚至化脓感染 蚂蚁到处爬行，喜吃甜食，容易把各种病菌带到人类易接触的场所或食物表面 蚂蚁有啃噬的习性，会对电子设施、各类管线和木材造成损失 蚂蚁繁殖能力强，雌蚁每天可产500枚以上卵，每个蚁巢的数量可达50万只 蚂蚁是社会性昆虫，可以完成极其复杂的分工和任务，这也使得它们可以在许多严苛的条件下生存 蚂蚁拜拜 快速 高效 安全 广谱 持久 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 诱饵站 拜耳超强“*屏蔽的关键字*库”，全力抵御后续蚂蚁入侵，效果更持久显著 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 现场勘查 展开勘查，快速找出屋内蚂蚁的所有活动点和滋生源 施药处理 根据客户家中情况合理使用点胶、喷洒灌注等处理 专业报告 无暇观察现场？一份专业报告让您对服务了如指掌 持续保障 我们为您提供90天质保，期间若蚂蚁问题未改善，我们将升级工程师，无偿返工 效果 快速见效 强效吸引蚂蚁，找准点位，效果立竿见影 连锁灭杀 药效在蚁群内传播，火力直指源头，多米诺效应快速灭巢 持久屏障 在合适区域做滞留喷洒处理，将建起长效保护网，将蚂蚁有效阻挡在外 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "跳蚤拜拜",
      id: "flea",
      product_name: 'tiaozao',
      img: "icon-6.svg",
      text: "摆脱瘙痒，安心入眠",
      index: 7,
      title: '灭除跳蚤_杀跳骚_专业上门除跳蚤服务-拜耳虫虫拜拜官网',
      keywords: '灭除跳蚤,专业除跳蚤服务公司,上门除虫',
      description: '虫虫拜拜采用拜耳科学喷洒方案，快速灭杀跳蚤成虫，疗程式治理，全面触达跳蚤藏匿点效果更加长久有效。',
      noscritp: '跳蚤的危害 跳蚤是寄生型吸血害虫，每天要消耗自身体重15倍的血液来维生。常见的有猫蚤、狗蚤、人蚤和鼠蚤 跳蚤最易感染宠物并随其传播。宠物被叮咬后会出现过敏、局部秃毛，长期可能导致贫血和其他血液传播疾病 人被跳蚤叮咬会引起局部组织的超敏反应，造成皮肤红肿瘙痒、心神不宁，严重者会出现贫血、皮肤过敏、炎症等症状 跳蚤是邪恶的病媒生物，可以传播绦虫，鼠疫、*屏蔽的关键字*士杆菌病，斑疹伤寒、肾综合征出血等严重疾病 跳蚤生命力顽强，数月不吃东西也能存活，除了寄生在动物体表，还常存在于床褥，地毯，家具等环境中 跳蚤拜拜 安全 无痕 全面 环保 长效 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 ULV冷烟雾机 德国原装进口设备，使药剂雾化更细致、更均匀，显著提升防治效果 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 沟通记录 工程师上门与您沟通，并对现场情况进行分析预估 现场勘查 展开全方位地毯式搜索，准确判断的滋生区域和来源 全面处理 拜耳科学喷洒方案，不给残留虫卵一丝机会 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 持续保障 服务完成后，我们的工程师和客服会不定期回访，并提供90天的免费质保 效果 快速灭杀 疗程式治理，100%灭杀家中活跃的跳蚤成虫 长效保障 滞留药剂为虫卵埋下“*屏蔽的关键字*”，即使处理时还未孵化的虫卵也能高效触达 持久预防 工程师服务结束后将给出专业科学的预防建议指导客户整改调整，效果更加长久有效 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "厨卫飞虫",
      id: "cw_fly",
      product_name: 'chuwei',
      img: "icon-7.svg",
      text: "源头阻断，还厨卫清洁",
      index: 8,
      title: '厨卫飞虫灭治_专业上门消灭厨卫飞虫服务-拜耳虫虫拜拜官网',
      keywords: '全国上门除虫公司,消灭蛾蚋,灭厨卫飞虫,除虫公司,上门除虫',
      description: '拜耳虫虫拜拜可以快速灭杀屋内的厨卫飞虫成虫，现场杀灭效率高，并从源头入手，标本兼治，减少后续滋生复发可能性。',
      noscritp: '厨卫小飞虫的危害 家中尤其是厨卫区域，常会见到一些小飞虫，常见的有蛾蚋、果蝇、蚤蝇、蕈蚊。它们通常成群结队，而且可能传播病菌 蛾蚋多滋生于积水区域，如污水池、厕所、地板积水、厨房水槽、潮湿抹布等，易接触和携带环境中的细菌 果蝇易受蔬果和发酵物质的吸引，许多蔬菜和水果都携带并滋生有果蝇虫卵，如杨梅、西瓜等 蚤蝇是食腐昆虫，厨房角落的食物残渣、厕所垃圾等会滋生蚤蝇，其身上易携带细菌，传播疾病 蕈蚊俗称小黑飞，多滋生于盆栽绿植中，喜欢阴暗潮湿的环境，会传染植物真菌及病毒 厨卫飞虫 快速 安全 环保 无痕 无忧 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 消*屏蔽的关键字*剂 高效杀菌，深层清洁管道、污水池、水槽等厨卫小飞虫的滋生源头 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 ULV冷烟雾机 德国原装进口设备，使药剂雾化更细致、更均匀，显著提升防治效果 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 现场勘查 展开全面、有针对性的勘查，锁定滋生源和感染区域 虫种鉴定 凭借多年经验和后台数据库，鉴别虫种并制定解决方案 施药处理 “海陆空”全方位治理，快速灭杀，清理源头 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 持续保障 服务完成后，我们的工程师和客服会不定期回访，并提供90天的免费质保 效果 快速灭杀 迅速灭杀屋内可见小飞虫，现场杀灭率达100%，效果立竿见影 标本兼治 有效控制源头，减少后续滋生复发可能性 持久预防 工程师服务结束后将给出专业科学的预防建议指导客户整改调整，效果更加长久有效 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "织物害虫",
      id: "clothes_carpet_pest",
      product_name: 'zhiwu',
      img: "icon-8.svg",
      text: "皮革织物，持久呵护",
      index: 9,
      title: '织物害虫灭治_专业上门除织物害虫服务-拜耳虫虫拜拜官网',
      keywords: '专业上门除害虫公司,织物害虫,衣蛾,皮蠹,除虫公司',
      description: '拜耳虫虫拜拜可以高效快速灭杀家中的织物/地毯害虫，滞留药剂为虫卵埋下“地雷”，孵化虫卵也能高效触达，效果更加长久有效。',
      noscritp: '织物/地毯害虫 织物/地毯害虫以天然蛋白质（角蛋白）为食，可能破坏羊毛、丝绸、棉花、皮革和羽毛等。常见的有：皮蠹、衣蛾 皮蠹能飞善爬，有时候好端端一件衣服，莫名其妙冒出小口子，看上去好像是被钩破了一样，其实就是这些虫子吃的 衣蛾能以人体皮屑和头发为食，幼虫多存在于衣帽间、软垫家具缝里，尤其是穿过或有泥污的衣物 除了会对衣物、家私等造成损害，这类害虫还可能污染食物 织物害虫 快速 安全 环保 无痕 长效 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 ULV冷烟雾机 德国原装进口设备，使药剂雾化更细致、更均匀，显著提升防治效果 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 现场勘查 展开勘查，锁定害虫的滋生源和感染区域 虫种鉴定 凭借多年经验和强大的数据库，快速鉴别虫种并制定方案 施药处理 “海陆空”全方位治理，快速灭杀，清理源头 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 持续保障 服务完成后，我们的工程师和客服会不定期回访，并提供90天的免费质保 效果 快速灭杀 100%快速灭杀家中活跃的织物/地毯害虫，效果立竿见影 长效保障 滞留药剂为虫卵埋下“*屏蔽的关键字*”，即使处理时还未孵化的虫卵也能高效触达 持久预防 工程师服务结束后将给出专业科学的预防建议指导客户整改调整，效果更加长久有效 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "蚊虫拜拜",
      id: "mosquito",
      product_name: 'wenchong',
      img: "icon-9.svg",
      text: "舒适夏日，再也没叮咬",
      index: 10,
      title: '灭除蚊虫_灭蚊子_专业上门驱蚊虫服务-拜耳虫虫拜拜官网',
      keywords: '灭蚊虫,灭孑孓,上门除虫,除虫公司,专业驱蚊虫服务',
      description: '虫虫拜拜采用拜耳科学喷洒方案，全面快速灭杀蚊虫，灭杀效率高，并对源头控制，有效控制蚊虫幼虫（孑孓），效果更长久有效。',
      noscritp: '蚊虫的危害 蚊虫随处可见且令人生厌，夏季本想换上清凉着装，却被蚊虫咬的全身是包，不仅奇痒难忍还影响美观 夜间蚊子还喜欢在你耳边高速振翅，发出嗡嗡声打扰你的睡眠 除了惹人厌烦外，蚊虫还被称作世界上的头号*屏蔽的关键字*，可以传播多种严重的疾病 蚊虫可以传播疟疾、登革热、丝虫病、乙型脑炎、肯孔肯亚病等，全球每年有80多万人死于蚊虫叮咬传播的疾病 蚊虫拜拜 全面 安全 无痕 环保 无忧 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 孑孓生长抑制剂 可用于饮用水的杀幼剂，快速见效，药效持久，从源头处理问题 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 ULV冷烟雾机 德国原装进口设备，使药剂雾化更细致、更均匀，显著提升防治效果 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 沟通记录 工程师上门与您沟通，并对现场情况进行分析预估 现场勘查 展开全方位地毯搜索，判断蚊虫可能的滋生区域 全面处理 拜耳科学喷洒方案，让蚊子无处遁形 预防方案 工程师会根据实际情况制定科学有效的预防建议，减少日后苍蝇入侵和滋生的风险 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 效果 快速灭杀 迅速灭杀家中活跃的蚊虫成虫，现场杀灭率达100% 源头控制 有效控制源头，标本兼治，高效触达蚊虫幼虫（孑孓），将蚊虫扼杀在襁褓之中 持久预防 工程师服务结束后将给出专业科学的预防建议指导客户整改调整，效果更加长久有效 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "衣鱼拜拜",
      id: "silverfish",
      product_name: 'yiyu',
      img: "icon-10.svg",
      text: "全面处理，书橱无忧",
      index: 11,
      title: '灭除衣鱼_专业上门消灭衣鱼服务-拜耳虫虫拜拜官网',
      keywords: '灭除衣鱼,上门除虫,除书虫,除虫公司,专业上门驱虫服务公司',
      description: '拜耳虫虫拜拜可以迅速灭杀家中的衣鱼（书虫）。拜耳科学喷洒方案，全面触达衣鱼可能隐藏的每一角落。',
      noscritp: '衣鱼的危害 衣鱼，亦称剪刀虫、蠹鱼等，是一种无翅小型昆虫，它能捱饿数月，身体机能也不会受到伤害 衣鱼喜暗潮湿，容易滋生于书柜、地板缝、书架、旧书等地方 衣鱼又称书虫，喜好吃糖类食物，纸张中的纤维素是其最爱的食物之一，容易对书籍、衣物造成损害 衣鱼食性杂乱，隐蔽场所多，行动敏捷，因此防治起来十分困难 衣鱼拜拜 快速 安全 无痕 环保 长效 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 沟通记录 工程师上门与您沟通，并对现场情况进行分析预估 现场勘查 展开全方位地毯式搜索，判断衣鱼的寄生区域和感染源 全面处理 拜耳科学喷洒方案，全面触达衣鱼可能隐藏的每一角落 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 持续保障 服务完成后，我们的工程师和客服会不定期回访，并提供90天的免费质保 效果 快速灭杀 迅速灭杀家中活跃的衣鱼成虫 效果持久 滞留药剂为虫卵埋下“*屏蔽的关键字*”，即使处理时还未孵化的虫卵也能高效触达 长效预防 工程师服务后将给出专业科学的预防建议指导客户整改调整，效果更加长久有效 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "臭虫拜拜",
      id: "bedbug",
      product_name: 'chouchong',
      img: "icon-11.svg",
      text: "还您安心舒适的床铺",
      index: 12,
      title: '灭除臭虫_专业上门消灭臭虫公司-拜耳虫虫拜拜官网',
      keywords: '上门去臭虫服务公司,灭杀臭虫,除虫公司,除臭虫公司,除虫服务',
      description: '拜耳虫虫拜拜采用疗程式治理方案，可以高效灭杀顽固臭虫。深度治理，还您舒适床铺，让您高枕无忧，保障优质睡眠。',
      noscritp: '臭虫的危害 臭虫又称床虱，通常发现于居室及床榻的各种缝隙中，是一种专性寄生虫，靠吸恒温动物的血为生 臭虫叮咬、吸血，会引发瘙痒、失眠、神经衰弱，严重的还会导致贫血症状 臭虫有一对臭腺，能分泌一种异常臭液，爬过的地方会留下难闻的臭味 酒店、电影院、国际航班、公共交通等是臭虫隐患高发场所，它可能通过行李、衣服、背包等被携带回家 臭虫繁殖迅速且耐饥饿力强，只要带回一只活的母臭虫，就有可能造成严重的臭虫侵害 臭虫拜拜 安全 环保 无痕 全面 长效 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 蒸汽清洁机 高温蒸汽，深度清洁，有效配合药剂处理，双管齐下 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 ULV冷烟雾机 德国原装进口设备，使药剂雾化更细致、更均匀，显著提升防治效果 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 沟通记录 工程师上门与您沟通，并对现场情况进行分析预估 现场勘查 展开全方位地毯式搜索，准确判断的滋生区域和来源 全面处理 拜耳科学喷洒方案，不给残留虫卵一丝机会 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 持续保障 服务完成后，我们的工程师和客服会不定期回访，并提供90天的免费质保 效果 灭杀彻底 疗程式治理，高效灭杀家中活跃的臭虫成虫 深度清洁 高温消毒，深度洁净床品，还您舒适床铺，让您高枕无忧，保障优质睡眠 效果持久 滞留药剂为虫卵埋下“*屏蔽的关键字*”，即使处理时还未孵化的虫卵也能高效触达，杜绝后患 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "苍蝇拜拜",
      id: "fly",
      product_name: 'cangying',
      img: "icon-12.svg",
      text: "锁定滋生源，全域灭杀",
      index: 13,
      title: '灭除苍蝇_专业上门消灭苍蝇服务-拜耳虫虫拜拜官网',
      keywords: '灭苍蝇,上门除虫,除虫公司',
      description: '虫虫拜拜采用拜耳科学喷洒方案，全面触达苍蝇可能隐藏的每一角落，灭杀效率高，并对感染源进行控制，有效减少日后苍蝇滋生可能性。',
      noscritp: '苍蝇的危害 苍蝇以人类和动物的粪便、尸体及生活垃圾为食，还有“边吃边吐边拉”的习惯，容易污染食物和餐具 苍蝇容易携带各种病原体，可以传播多种疾病，如霍乱、伤寒、痢疾、肝炎、脊髓灰质炎病、甲肝乙肝等 苍蝇四处乱飞，发出的嗡嗡声会给住户正常的生活工作带来严重滋扰 家蝇是最为常见的苍蝇，繁殖能力惊人，每次产卵可达120-150粒 苍蝇拜拜 安全 全面 无痕 环保 无忧 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 ULV冷烟雾机 德国原装进口设备，使药剂雾化更细致、更均匀，显著提升防治效果 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 沟通记录 工程师上门与您沟通，并对现场情况进行分析预估 现场勘查 根据已掌握的信息展开全方位地毯式搜索，准确判断苍蝇的吸引源和繁殖点 全面处理 采用拜耳科学喷洒方案，全面触达苍蝇可能隐藏的每一角落 预防方案 工程师会根据实际情况制定科学有效的预防建议，减少日后苍蝇入侵和滋生的风险 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 效果 快速灭杀 迅速灭杀家中活跃的苍蝇成虫，现场杀灭率达100%，效果立竿见影 源头治理 对苍蝇滋生地、感染源进行控制，显著降低其密度，有效减少日后苍蝇入侵和滋生的可能性 持久预防 工程师服务结束后将给出专业科学的预防建议指导客户整改调整，效果更加长久有效 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    }
  ],
  newabout_list: [
    {
      name: "蚊虫拜拜",
      id: "mosquito",
      product_name: 'wenchong',
      img: "icon-wybb.svg",
      text: "舒适夏日，再也没叮咬",
      index: 10,
      title: '灭除蚊虫_专业上门驱蚊虫服务-拜耳虫虫拜拜官网',
      keywords: '灭蚊虫,灭孑孓,上门除虫,除虫公司,专业驱蚊虫服务',
      description: '虫虫拜拜采用拜耳科学喷洒方案，全面快速灭杀蚊虫，灭杀效率高，并对源头控制，有效控制蚊虫幼虫（孑孓），效果更长久有效。',
      noscritp: '蚊虫的危害 蚊虫随处可见且令人生厌，夏季本想换上清凉着装，却被蚊虫咬的全身是包，不仅奇痒难忍还影响美观 夜间蚊子还喜欢在你耳边高速振翅，发出嗡嗡声打扰你的睡眠 除了惹人厌烦外，蚊虫还被称作世界上的头号*屏蔽的关键字*，可以传播多种严重的疾病 蚊虫可以传播疟疾、登革热、丝虫病、乙型脑炎、肯孔肯亚病等，全球每年有80多万人死于蚊虫叮咬传播的疾病 蚊虫拜拜 全面 安全 无痕 环保 无忧 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 孑孓生长抑制剂 可用于饮用水的杀幼剂，快速见效，药效持久，从源头处理问题 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 ULV冷烟雾机 德国原装进口设备，使药剂雾化更细致、更均匀，显著提升防治效果 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 沟通记录 工程师上门与您沟通，并对现场情况进行分析预估 现场勘查 展开全方位地毯搜索，判断蚊虫可能的滋生区域 全面处理 拜耳科学喷洒方案，让蚊子无处遁形 预防方案 工程师会根据实际情况制定科学有效的预防建议，减少日后苍蝇入侵和滋生的风险 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 效果 快速灭杀 迅速灭杀家中活跃的蚊虫成虫，现场杀灭率达100% 源头控制 有效控制源头，标本兼治，高效触达蚊虫幼虫（孑孓），将蚊虫扼杀在襁褓之中 持久预防 工程师服务结束后将给出专业科学的预防建议指导客户整改调整，效果更加长久有效 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "白蚁灭治",
      id: "white_ant_check",
      product_name: 'baiyikancha',
      img: "icon-bykc.svg",
      text: "护卫房屋装潢",
      index: 4,
      title: '白蚁灭治_专业上门除白蚁服务-拜耳虫虫拜拜官网',
      keywords: '白蚁灭治,白蚁勘察,白蚁危害,白蚁公司,白蚁灭治服务公司',
      description: '白蚁会严重危害房屋建筑且入侵不易察觉。拜耳虫虫拜拜提供专业的白蚁勘查和灭治服务，为您竖起保护建筑的“金钟罩”。',
      noscritp: '白蚁的危害 白蚁和蚂蚁完全不同，和蟑螂反而是近亲，是一种严重危害房屋建筑的害虫 它能蛀食书籍、家具、地板、房屋、桥梁堤坝等，破坏力极大 白蚁入侵途径多样，3-6月是它的婚飞季，30多层的高层都有可能被入侵 白蚁蚁后繁殖能力超强，每天能产生上万个卵，有些品种的蚁后甚至可以孤雌繁殖 白蚁侵害不易发觉，被称为“无声破坏者”，被发现时往往已经造成巨大损失 白蚁灭治 精准 预防 安全 长效 灭巢 服务热线： 400-188-8282 快速预约 江浙沪地区最易遭受三种白蚁入侵 台湾乳白蚁 世界上危害最大的白蚁，破坏力最强，轻易入侵高层建筑 黑胸散白蚁 一个蚁群有数千只，破坏主要集中在建筑低层区域 黄胸散白蚁 婚飞季节最早，蚁道隐蔽不易发现 什么情况下您亟需白蚁灭治？ 1 地板表面起泡、掉漆，地板松动翘起 2 地板表面起泡、掉漆，地板松动翘起 3 地板表面起泡、掉漆，地板松动翘起 4 地板表面起泡、掉漆，地板松动翘起 然而大多数情况下白蚁入侵的迹象隐蔽而不易察觉，待意识到问题时往往白蚁已在家中筑巢，数量和危害已经到达比较严重的程度。因此，若您家中符合以下任意一种情况，您也可以请专业的工程师上门勘查，未雨绸缪。 家中装修配置了较多的木制家具 之前家中出现过渗水情况，尤其是木制结构区域 房屋外围绿化率高，春夏季常有白蚁纷飞 发现周围邻居家中有白蚁问题 专业工具 拜耳专业药剂 WHO推荐的非趋避性产品，安全低毒，药效持久 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 建筑工具和材料 进口五金器械和密封修补材料，确保破坏最小、复原最佳 智能分析管理平台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 效果 地上型蚁站安装方便，大大减少人工成本，无需破坏任何室内装潢 地下型蚁站埋设在地下，将需要保护的区域包围起来，可对该区域的白蚁进行有效的检测和拦截 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "蟑螂拜拜",
      id: "cockroach",
      product_name: 'zhanglang',
      img: "icon-zlbb.svg",
      text: "56个排查点，3月质保",
      index: 2,
      title: '灭除蟑螂_专业上门消灭蟑螂服务-拜耳虫虫拜拜官网',
      keywords: '除蟑螂,上门除蟑螂,上门除虫,蟑螂胶饵',
      description: '拜耳虫虫拜拜可以快速灭除蟑螂。自有工程师团队将根据现场环境，使用拜耳官方正品药剂对症下药，强效吸引，隔夜见效，效果持久。',
      noscritp: '蟑螂的危害 蟑螂是食腐动物，几乎所有东西都可能成为它的食物。而且它边吃边拉，会对食物和生活环境造成污染 小强携带约40种病菌，可能引发哮喘、肺炎、痢疾、结核病、白喉、猩红热等疾病（数据来源于中国疾控中心） 一只雌性德国小蠊一年可繁衍10,000只后代。加上它是群居性昆虫，看到一只往往意味着有更多躲在暗处 蟑螂喜欢昼伏夜出、钻缝藏洞，常通过快递盒、外卖包装等潜入家中。电话机、游戏机、冰箱缝都可能是它的栖身处 蟑螂有最原始的咀嚼式口器，会咬坏电线线路等物品，造成事故隐患 蟑螂拜拜 快速 长效 安全 无痕 无忧 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 诱饵站 根据蟑螂生物习性设计，独特纹路引导小强上钩，超强“*屏蔽的关键字*库”使效果更持久显著 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 现场勘查 厨房、卫生间等56个排查点，让蟑螂无处遁形 环境分析 工程师结合专业生物知识对您家中情况进行剖析 施药处理 蟑螂也分好多种，对症下药才是关键 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 长效保障 我们为您提供90天质保，期间若蟑螂问题未改善，我们将升级工程师，无偿返工 效果 强效吸引 独特配方技术，蟑螂即使拒食葡萄糖也难抵我们专业药剂的诱惑 隔夜见效 新ContaX触杀技术、多米诺效应双效合一；服务后第二天即可见效，1-2周蟑螂无影无踪 隐形屏障 工程师施药点安全隐蔽，为您撑起隐形屏障，一次服务，长效保障 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "跳蚤拜拜",
      id: "flea",
      product_name: 'tiaozao',
      img: "icon-tzbb.svg",
      text: "摆脱瘙痒，安心入眠",
      index: 7,
      title: '灭除跳蚤_专业上门除跳蚤服务-拜耳虫虫拜拜官网',
      keywords: '灭除跳蚤,专业除跳蚤服务公司,上门除虫',
      description: '虫虫拜拜采用拜耳科学喷洒方案，快速灭杀跳蚤成虫，疗程式治理，全面触达跳蚤藏匿点效果更加长久有效。',
      noscritp: '跳蚤的危害 跳蚤是寄生型吸血害虫，每天要消耗自身体重15倍的血液来维生。常见的有猫蚤、狗蚤、人蚤和鼠蚤 跳蚤最易感染宠物并随其传播。宠物被叮咬后会出现过敏、局部秃毛，长期可能导致贫血和其他血液传播疾病 人被跳蚤叮咬会引起局部组织的超敏反应，造成皮肤红肿瘙痒、心神不宁，严重者会出现贫血、皮肤过敏、炎症等症状 跳蚤是邪恶的病媒生物，可以传播绦虫，鼠疫、*屏蔽的关键字*士杆菌病，斑疹伤寒、肾综合征出血等严重疾病 跳蚤生命力顽强，数月不吃东西也能存活，除了寄生在动物体表，还常存在于床褥，地毯，家具等环境中 跳蚤拜拜 安全 无痕 全面 环保 长效 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 ULV冷烟雾机 德国原装进口设备，使药剂雾化更细致、更均匀，显著提升防治效果 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 沟通记录 工程师上门与您沟通，并对现场情况进行分析预估 现场勘查 展开全方位地毯式搜索，准确判断的滋生区域和来源 全面处理 拜耳科学喷洒方案，不给残留虫卵一丝机会 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 持续保障 服务完成后，我们的工程师和客服会不定期回访，并提供90天的免费质保 效果 快速灭杀 疗程式治理，100%灭杀家中活跃的跳蚤成虫 长效保障 滞留药剂为虫卵埋下“*屏蔽的关键字*”，即使处理时还未孵化的虫卵也能高效触达 持久预防 工程师服务结束后将给出专业科学的预防建议指导客户整改调整，效果更加长久有效 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "老鼠拜拜",
      id: "rats",
      product_name: 'laoshu',
      img: "icon-lsbb.svg",
      text: "全面处理，杜绝隐患",
      index: 3,
      title: '灭除老鼠_专业上门除老鼠服务-拜耳虫虫拜拜官网',
      keywords: '上门除老鼠,捉老鼠,除虫公司',
      description: '拜耳自有工程师团队，帮您识别隐蔽鼠迹，通过布控关键点快速捕捉老鼠，并找出建筑环境风险点，使用专业材料封堵，消除后续隐患。',
      noscritp: '老鼠的危害 现实中的老鼠黑不溜秋尖嘴缩腮，可不是荧幕上的可爱形象，如果潜入您家，可能带来巨大的危害 老鼠是啮齿类动物，容易对线路、通讯、家具甚至房屋结构造成破坏，引发事故 老鼠常出没于下水道、垃圾堆，能传播35种以上疾病，如流行性出血热、班疹伤寒、狂犬病、鼠疫等 老鼠繁殖迅速，一对褐家鼠一年可以繁衍2，000只后代。千防万防，老鼠难防 老鼠可以钻过6mm的孔洞，还有惊人的听觉、嗅觉、触觉，十分谨慎聪明，智商比肩5岁小孩 老鼠拜拜 精准 安全 全面 环保 智能 服务热线： 400-188-8282 快速预约 专业工具 Bell trap gel 美国贝尔实验室特效引诱剂，根据老鼠喜好设计的特殊风味，效果卓著，安全环保 强力粘鼠板 中日合资企业出品，全国爱卫会推荐产品，超强黏胶，让老鼠束手就擒 拜耳专业药剂 独特剂型，安全高效，有效解决老鼠拒食困扰 红外线捕鼠器 自动感应，连续捕鼠，再聪明狡猾的老鼠也难逃法网 封堵材料 多种专业封堵材料，兼顾美观的同时从根本上阻绝老鼠的来路 专业服务 服务工序 追踪鼠迹 识别排泄物、脚印、咬痕和毛发擦痕，描绘活动路径 环境分析 全方位环境分析，找出建筑和环境的所有风险点 全面处理 多次上门诱捕灭防，不给老鼠留一丝机会 专业报告 无暇观察现场？专业的事交给专业的人。一份专业报告让您对服务了如指掌 持续保障 服务完成后，我们的工程师和客服会不定期回访，并提供90天的免费质保 效果 快速捕获 工程师准确判断室内是否仍有老鼠藏匿，并设置陷阱快速捕获躲藏的老鼠 高效灭杀 只要取食，甚至是沾染了我们的拜耳专业药剂，老鼠就会中招 杜绝隐患 科学细致的孔洞封堵工作，将潜在隐患因子有效隔绝 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    },
    {
      name: "蚂蚁拜拜",
      id: "ants",
      product_name: 'mayi',
      img: "icon-mybb.svg",
      text: "连锁灭杀，立竿见影",
      index: 6,
      title: '蚂蚁防治_专业上门除蚂蚁服务-拜耳虫虫拜拜官网',
      keywords: '除蚂蚁,除白蚁公司,上门除虫,蚂蚁防治方法',
      description: '虫虫拜拜使用拜耳官方正品药剂，强效吸引蚂蚁；专业工程师展开勘查，快速找出屋内蚂蚁活动点和滋生源，连锁灭杀，立竿见影。',
      noscritp: '蚂蚁的危害 一些蚂蚁如小黄家蚁、红火蚁等会叮咬人，特别是小孩，引起皮肤发炎红肿，甚至化脓感染 蚂蚁到处爬行，喜吃甜食，容易把各种病菌带到人类易接触的场所或食物表面 蚂蚁有啃噬的习性，会对电子设施、各类管线和木材造成损失 蚂蚁繁殖能力强，雌蚁每天可产500枚以上卵，每个蚁巢的数量可达50万只 蚂蚁是社会性昆虫，可以完成极其复杂的分工和任务，这也使得它们可以在许多严苛的条件下生存 蚂蚁拜拜 快速 高效 安全 广谱 持久 服务热线： 400-188-8282 快速预约 专业工具 拜耳专业药剂 HACCP认证，美国EPA登记、WHO推荐产品、ICAMA登记，对人和宠物安全友好 专业喷雾器 配备4款喷头，灵活应对各种喷洒场景，深入房屋角角落落，任何一个缝隙也不放过 诱饵站 拜耳超强“*屏蔽的关键字*库”，全力抵御后续蚂蚁入侵，效果更持久显著 智能分析管理后台 后台根据工程师上传的关键数据生成专业报告。服务全程监测可追溯，安全可靠有保障 专业服务 服务工序 现场勘查 展开勘查，快速找出屋内蚂蚁的所有活动点和滋生源 施药处理 根据客户家中情况合理使用点胶、喷洒灌注等处理 专业报告 无暇观察现场？一份专业报告让您对服务了如指掌 持续保障 我们为您提供90天质保，期间若蚂蚁问题未改善，我们将升级工程师，无偿返工 效果 快速见效 强效吸引蚂蚁，找准点位，效果立竿见影 连锁灭杀 药效在蚁群内传播，火力直指源头，多米诺效应快速灭巢 持久屏障 在合适区域做滞留喷洒处理，将建起长效保护网，将蚂蚁有效阻挡在外 工程师 专职员工，背景尽调，严格筛选 3年以上行业经验 国家专业资格证书认证 90课时拜耳内部理论实操课程培训'
    }
  ],

  product_mobile_list: [
    {
      product_id: 'white_ant_check',
      product_name: '白蚁灭治',
      detail: '护卫房屋装潢',
      bg_img: 'service_baiyi_bg.png',
      icon_img: 'icon-4.svg'
    },
    {
      product_id: 'cw_fly',
      product_name: '厨卫飞虫',
      detail: '源头阻断，还厨卫清洁',
      bg_img: 'service_feichong_bg.png',
      icon_img: 'icon-8.svg'
    },
    {
      product_id: 'flea',
      product_name: '跳蚤拜拜',
      detail: '摆脱瘙痒，安心入眠',
      bg_img: 'service_tiaozao_bg.png',
      icon_img: 'icon-7.svg'
    }
  ],
  customer_testimony: [
    {
      product_name: '蟑螂拜拜',
      text: '工作人员十分守时，按照约定时间登门服务。工作耐心细致，会帮助回答关于杀虫的各类疑问，会仔细查看房间脚脚落落，放置药品时也会放的很仔细。',
      img: 'squarename.png',
      customer: '***生'
    },
    {
      product_name: '老鼠拜拜',
      text: '本来第二次约好8:30，但是因为有事，希望谢师傅能早点到，电话沟通后，谢师傅一口就答应了，第二天一大早就来了。既专业又认真，五星好评！',
      img: 'squarename.png',
      customer: '***士'
    },
    {
      product_name: '白蚁灭治',
      text: '刘工程师操作很仔细，很规范，并对客户详细说明。整个灭蚁过程做得很完美，使我们很放心，谢谢！',
      img: 'squarename.png',
      customer: '***贤'
    },
    {
      product_name: '蟑螂拜拜',
      text: '初到上海，一只超大小强着实吓到我了，连夜联系除小强，谢谢倪师傅，非常仔细的处理了各处死角，贴心的服务！ 谢谢倪师傅！谢谢拜耳！',
      img: 'squarename.png',
      customer: '***冰'
    },
    {
      product_name: '白蚁灭治',
      text: '这是装修拆除的杀虫，毛先生特别认真负责，而且在紧急请求时牺牲个人时间前来帮助，非常感动，房子里现在已经没有白蚁了',
      img: 'squarename.png',
      customer: '***丽'
    },
    {
      product_name: '臭虫拜拜',
      text: '>师傅认真负责，给了很多好建议。还对保护宠物方面很仔细喷药。值得信赖的师傅！',
      img: 'squarename.png',
      customer: '***士'
    },
    {
      product_name: '老鼠拜拜',
      text: '工程师很准时，非常专业很负责的帮忙找老鼠的来源，并堵住洞口，花了2个多小时，那么热的天，衣服都湿透了，服务很棒，非常满意！',
      img: 'squarename.png',
      customer: '***知'
    },
    {
      product_name: '叮蛰害虫',
      text: '找出了我们实验室小红蚂蚁其实是叫肿腿蜂的一种昆虫。',
      img: 'squarename.png',
      customer: '***士'
    },
    {
      product_name: '跳蚤拜拜',
      text: '非常感谢贵公司毛工程师的服务，专业、敬业、热情，对工作一丝不苟。',
      img: 'squarename.png',
      customer: '***英'
    },
    {
      product_name: '蟑螂拜拜',
      text: '徐工程师非常的耐心讲解了防虫要点，服务很仔细，态度认真，期待防治效果',
      img: 'squarename.png',
      customer: '***姐'
    },
    {
      product_name: '衣鱼拜拜',
      text: '师傅超级好叻 检查仔细 药水也喷的很到位。好评100昏。下次我隔断时间就要拜耳叻 这样才能放心。',
      img: 'squarename.png',
      customer: '***凌'
    },
    {
      product_name: '老鼠拜拜',
      text: '认真负责，技术过硬',
      img: 'squarename.png',
      customer: '***生'
    },
    {
      product_name: '老鼠拜拜',
      text: '技师服务态度很好很专业，非常感谢',
      img: 'squarename.png',
      customer: '***巍'
    },
    {
      product_name: '专业上门检测',
      text: '非常感谢工程师！！！！之前天天看到虫都有心理阴影了。工程师非常善解人意的安慰了我和家人并且找到了源头。终于能睡个踏实觉了_(:з」∠)_',
      img: 'squarename.png',
      customer: '***婧'
    },
    {
      product_name: '蟑螂拜拜',
      text: '工程师很专业，拜耳在除虫前和除虫后都有客服来电，感觉服务很到位，会推荐给朋友',
      img: 'squarename.png',
      customer: '**士'
    },
    {
      product_name: '蟑螂拜拜',
      text: '弄得很仔细，第二天就见效果了，没想到除虫还可以这么专业，还有家里有宝宝，也不用担心',
      img: 'squarename.png',
      customer: '***0'
    }
  ],
  //首页增强电商商品(第一次加载进来)
  commodityEnhanced:[
    {
      'event': 'ecProductImpression',
      'ecommerce': {
        'currencyCode': 'CNY',
        'impressions': [
          {
            'name': '白蚁灭治',
            'id': 'white_ant_check',
            'category': '',
            'price': '',
            'position': 1,
            'dimension102': 'white_ant_check',
            'dimension108': '白蚁',
            'dimension109': 'baiyikancha'

          },
          {
            'name': '蟑螂拜拜',
            'id': 'cockroach',
            'category': '',
            'price': '',
            'position': 2,
            'dimension102': 'cockroach',
            'dimension108': '蟑螂',
            'dimension109': 'zhanglang'

          },
          {
            'name': '老鼠拜拜',
            'id': 'rats',
            'category': '',
            'price': '',
            'position': 3,
            'dimension102': 'rats',
            'dimension108': '老鼠',
            'dimension109': 'laoshu'

          }
        ]}
    }
  ],
  //首页增强电商商品
  commodity:[
    [
      {
        'name': '白蚁灭治',
        'id': '',
        'category': '',
        'price': '',
        'position': 1,
        'dimension102': 'white_ant_check',
        'dimension108': '白蚁灭治',
        'dimension109': 'Termite Treatment'
      },
    ],
    [
      {
        'name': '厨卫飞虫',
        'id': '',
        'category': '',
        'price': '',
        'position': 1,
        'dimension102': 'cw_fly',
        'dimension108': '厨卫飞虫',
        'dimension109': 'Kitchen Pests'
      },
    ],
    [
      {
        'name': '跳蚤拜拜',
        'id': '',
        'category': '',
        'price': '',
        'position': 1,
        'dimension102': 'flea',
        'dimension108': '跳蚤',
        'dimension109': 'Flea'
      },
    ],
    [
      {
        'name': '蟑螂拜拜',
        'id': '',
        'category': '',
        'price': '',
        'position': 2,
        'dimension102': 'cockroach',
        'dimension108': '蟑螂拜拜',
        'dimension109': 'Cockroaches'

      },
    ],
    [
      {
        'name': '老鼠拜拜',
        'id': '',
        'category': '',
        'price': '',
        'position': 3,
        'dimension102': 'rats',
        'dimension108': '老鼠拜拜',
        'dimension109': 'Rats'
      }
    ],

  ],
  //根据id图标显示
  icon_id_name: {
    'cockroach': {
      name: '蟑螂拜拜',
      iconName: 'iconn-cockroach',
    },
    'flea': {
      name: '跳蚤拜拜',
      iconName: 'iconn-tiaozao',
    },
    'ants': {
      name: '蚂蚁拜拜',
      iconName: 'iconn-ants',
    },
    'rats': {
      name: '老鼠拜拜',
      iconName: 'iconn-rats',
    },
    'bees': {
      name: '叮蛰害虫',
      iconName: 'iconbees',
    },
    'woods_pest': {
      name: '蛀木害虫',
      iconName: 'iconwoods_pest',
    },
    'cw_fly': {
      name: '厨卫飞虫',
      iconName: 'iconcw_fly',
    },
    'clothes_carpet_pest': {
      name: '织物害虫',
      iconName: 'iconn-zhiwu',
    },
    'fly': {
      name: '苍蝇拜拜',
      iconName: 'iconfly2',
    },
    'silverfish': {
      name: '衣鱼拜拜',
      iconName: 'iconsilverfish',
    },
    'bedbug': {
      name: '臭虫拜拜',
      iconName: 'iconbedbug',
    },
    'mosquito': {
      name: '蚊虫拜拜',
      iconName: 'iconmosquito',
    },
    'cockroach_upgrade': {
      name: '蟑螂服务升级',
      iconName: 'iconn-cockroach',
    },
    'unknownpest2': {
      name: '专业上门检测',
      iconName: 'iconspecialty',
    },
    'pest_prevention': {
      name: '综合虫害预防',
      iconName: 'iconother',
    },
    'white_ant_precaution': {
      name: '白蚁预防',
      iconName: 'iconwhite_ant_prevent',
    },
    'white_ant_check': {
      name: '白蚁灭治',
      iconName: 'iconwhite_ant_check',
    },
    'white_ant_cure': {
      name: '白蚁防治方案',
      iconName: 'iconwhite-ant-cure',
    },
    'villa_package_A': {
      name: '尊享版包年套餐',
      iconName: 'iconvillas',
    },
    'pest_management': {
      name: '综合虫害管家服务',
      iconName: 'iconvillas',
    },
    'villa_package_B': {
      name: '蚊虫拜拜',
      iconName: 'iconn-feichong',
    },
    'garden_pests': {
      name: '花园害虫',
      iconName: 'iconn-huayuan',
    },
    'mite': {
      name: '寄螨',
      iconName: 'iconn-mite',
    },
    'multipod_pests': {
      name: '多足害虫',
      iconName: 'iconn-multipod-pests',
    },
    'swollen_leg_bee': {
      name: '肿腿蜂',
      iconName: 'iconswollen-leg-bee',
    },
    'storage_pests': {
      name: '仓储害虫',
      iconName: 'iconstorage-pests',
    },
    'wet_pests': {
      name: '潮湿害虫',
      iconName: 'iconn-wet-pests',
    },
    'general_ant': {
      name: '分飞蚁边界防制',
      iconName: 'iconwhite_ant_prevent',
    },
    'rats_upgrade': {
      name: '老鼠服务升级',
      iconName: 'iconn-rats',
    },
    'party_prepair': {
      name: '派对活动准备',
      iconName: 'iconparty',
    },
    'home_check': {
      name: '上门勘察',
      iconName: 'iconspecialty',
    },
    'home_check_result': {
      name: '专业定制化方案',
      iconName: 'iconhome_check_result',
    },
  },
}
module.exports = $data;



// WEBPACK FOOTER //
// ./src/controller/data.js